import { observable, action, flow, computed, toJS, runInAction } from 'mobx';
import Util from 'utils';
import { initConfig } from 'utils/wxUtils';
import { shareFriend, sharePyq } from 'utils/wxShare';
import Config from 'config/Config';
import Stores from 'config/Stores';
import { Toast, Modal } from 'antd-mobile';
import _, { get, isArray, cloneDeep, multiply } from 'lodash';
import {
  activityTypeMap,
  advanceSaleStatusMap,
  advanceSaleTypeMap,
  payActivityTypeMap,
  routeAuthCodeMap
} from 'utils/constants';
import { formatTime } from 'utils/FormatUtil';
import Serv from './ProductDetailServ';
import {
  getIsUnsubscribeOrSleep,
  getThinUserState
} from 'biz-micro-services-ui/project/middlePlatform/function/globalState';

/**
 * 取交集
 */
function getArrEqual(arr1, arr2) {
  let newArr = [];
  for (let i = 0; i < arr2.length; i++) {
    for (let j = 0; j < arr1.length; j++) {
      if (`${arr1[j]}`.trim() == `${arr2[i]}`.trim()) {
        newArr.push(`${arr1[j]}`.trim());
      }
    }
  }
  return newArr;
}

class ProductDetailMod {
  // 活动下载弹窗标记
  @observable activityAppDownloadGuide = false;
  // 是否提示下载弹窗
  @observable appDownloadGuide = false;
  // 活动类型 1 - 满减, 2 - 满赠实, 3 - 满赠券, 4 - 满减权, 5 - 折扣, 6 - 加价购, 7 - 预售, 8 - 拼团, 9 - 秒杀，10 - 资格购
  @observable activityType = '';

  // 1, 只能观看 2, 跳转到购买页面
  @observable preView = '';

  @observable applyType = '';

  @observable card = {};

  @observable activeKeyList = '';

  @observable fromSource = '';

  @observable itemValue = '';

  @observable keyword = '';

  @observable productId = '';

  @observable autoComplete = -1;

  @observable activityId = '';

  @observable newSource = '';

  // 自定义专题页 专用  --> 默认选中当前活动类型项 其他活动不使用
  @observable selActId = '';

  // 1-商品 2-实物组合 3-虚拟组合
  @observable type = 1;

  // 产品信息
  @observable productInfo = {};
  @observable loadingProductInfo = true;

  // 多规格商品
  @observable moreSpecificationsData = [];
  // 选中的多规格商品
  @observable checkItem = {};

  @observable showSkuModal = false;

  // 产品推荐列表
  @observable recommendList = [];

  // 订单类型
  @observable orderType = '1';

  // 配货比例(1、1比1配货； 2、1比2配货；3、1比3配货) 新零售 默认选中1
  @observable orderProperty = '';

  @observable orderTypeList = [];

  @observable distributionRatioList = [];

  // 新零售折扣
  @observable discount = '';

  @observable itemMinBuy = 1;

  @observable itemNum = 1;

  // 最大可购买数量
  @observable limitNum = 0;

  // 是否已收藏
  @observable isCollected = false;

  // 真实的收藏状态
  @observable realCollected = false;

  // 推荐组合产品
  @observable bundleList = [];

  // 活动促销信息
  @observable promoteInfo = {};

  // 立即购买里的活动列表
  @observable activityList = [];

  // 底部按钮栏有效性，能否点击
  @observable bottomToolBarDisabled = false;

  // 立即购买里的不可用活动列表
  @observable disabledActivityList = [];

  // 秒杀拼团预售等活动信息
  @observable activityInfo = null;

  @observable preZiGeActivity = {};

  @observable NowPriceAndBvInfo = {};

  @observable source = 0;

  // 拼团成团信息
  @observable groupBuyList = {
    data: [],
    pageNum: 1,
    pages: 1,
    total: 0
  };

  // 拼团成团数量
  memberCount = '';

  // 预售说明(定金、尾款时间)
  @observable adVanceExplain = [];

  // 活动规则
  @observable description = '';

  // 是否允许不带活动下单 0 允许  1 禁止
  @observable notCancelTag = 0;

  // 当前预售状态
  advanceSaleStatus = '';

  // 已经获取库存
  @observable hasRequestStock = false;

  // 满赠列表
  @observable giftList = [];

  // 满赠对应的活动id 集合
  @observable giftListActivity = [];

  // 选赠品对象
  @observable modalObject = {};

  // 赠品活动id
  @observable giftActId = '';

  // 记录已选赠品项id
  @observable selectedGiftItems = {};

  // 记录已选赠品项id副本
  @observable selectedGiftItemsArray = {};

  // 记录已选赠品所有数据
  // @observable selectedGiftListItems = {};

  // 当前临时选择的商品列表
  @observable selectedGiftList = [];

  // 赠品类型，1：实物赠品，2：兑换券类，3：虚拟权益
  @observable giftType = '';

  // 赠送数量
  @observable presentCount = '';

  // 赠送方式，1：全部赠送，2：任选几款 3: 任选几件
  @observable presentWay = '';

  // 加价购商品列表
  @observable incPriceList = [];

  // 当前选中的加价购活动
  @observable incPriceId = '';

  // 加价购是否随机
  @observable incRand = 0;

  // 加价购盲盒图片
  @observable blessingBagImg = '';

  // 加价购盲盒别名
  @observable blessingBagAlias = '';

  // 加价购最多允许选择的数量
  @observable maxIncPriceNum = 0;

  // 加价购单个商品金额
  @observable incPriceMoney = 0;

  // giftListSeckill 秒杀赠品
  @observable giftListSeckill = [];

  // 加价购类型，1-金额加价购，其他-折扣加价购
  @observable incPriceType = 0;

  @observable flag = 1;

  @observable showSpecModal = false;

  @observable joinGroupFlag = 1;

  // 检验是否可购买/参团校验结果
  @observable checkData = {
    data: {},
    activityType: 0,
    returnType: '',
    tradeNo: ''
  };

  // 当前商品不可用
  @observable unable = false;
  // 默认赠送礼品活动列表
  @observable defaultActivityList = [];

  @observable bizDefaultGiveawayReqDto = {};

  @observable titleName = '';
  @observable shareId = '';
  @observable bannerDetails = {};
  //是否有推荐文章
  @observable isRecommendArticle = true;
  //推荐文章列表
  @observable recommendArticleList = [];
  //推荐素材列表
  @observable recommendMaterialList = [];
  // 代客信息
  dgInfo = {};
  //问答列表
  @observable questionList = [];
  //评论列表
  @observable evaluateList = [];

  @observable getActiveList = [];
  @observable getActiveListForTag = [];
  // 资格购前端隐藏，可以通过跳转链接参与活动
  @observable showFlag = false;

  // 产品黑名单
  @observable blackActList = [];

  //秒杀活动是否允许与满赠活动叠加
  flashSaleFullToGiveSuperpositionTag = false;

  //是否来自甄选商城
  isFromSelectMall = false;

  //浏览商品成功之后的返回值
  coninSuccessData = {};

  isBean = false;

  //选择的地址信息
  @observable addressInfo = {};

  // 未登陆的情况下，是否存在下载app的权限点
  @observable hasPermissions = false;

  @observable freeShippingData = {
    amount: 0, //还差多少包邮
    showType: 0 //0-无包邮 1-为满包邮  2-包邮
  };

  // 入口名称，仅用于生命周期埋点
  @observable inletTitle = '';
  // 来源标签，记录订单来源链路
  @observable sourceTag = '';

  // 资格购活动是否允许取消活动以及必须下复消订单 0-不可取消且只能下复消订单 1-可取消可下任何订单类型
  qualificationUnCancel = false;

  // 资格购活动是否允许跨越用户支持的配货比例下单
  cargoScalePriorityTag = 0;

  beanItemId = ''; // 云豆id

  // 活动详情
  @observable activityDetail = {};
  @observable globalSaleMode = ''; // 产品销售属性
  // 宫主会 隐藏收藏、分享图标以及BV字段 默认零售1:1下单
  @observable isPriaItem = false;
  // 宫主会购物车产品数量
  @observable priaCount = 0;

  @observable shareLink = '';

  @observable invitationUserId = ''; // 特殊场景分享用户id

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  @computed get hideOrderTypeListAndDiscountMode() {
    const { orderTypeList, orderType, distributionRatioList, col2List } = this;
    console.log('orderTypeorderTypeorderTypess', orderType);
    console.log('orderTypeListss', orderTypeList);

    const nowdistribution = toJS(col2List[orderType]);
    const type =
      orderTypeList.length === 1 && Array.isArray(nowdistribution) && nowdistribution.length === 1;
    // return this.isFromSelectMall || type;
    return type;
  }

  @action
  resetIncPrice() {
    this.selectedGiftItems = {};
    this.selectedGiftItemsArray = {};
    this.incPriceList = [];
    this.incRand = 0;
    this.blessingBagImg = '';
    this.blessingBagAlias = '';
    this.maxIncPriceNum = 0;
    this.incPriceMoney = 0;
    this.incPriceType = 0;
  }

  @action
  changeIncPriceCount(index, value) {
    let incPriceList = [...this.incPriceList];
    incPriceList[index].itemNum = value;
    this.incPriceList = incPriceList;
  }

  @computed
  get ldFloor() {
    return Stores.AppMod.isLD && this.orderType == '1' && this.orderProperty > 1;
  }

  @computed
  get isVipRebuy() {
    if (!this.activityList || this.activityList.length == 0) {
      return false;
    }
    let flag = false;
    for (const activity of this.activityList) {
      if (activity.activityBaseInfoList && activity.activityType === 6) {
        for (const item of activity.activityBaseInfoList) {
          if (item.vipUpgradeActivity === 1 && item.selected) {
            flag = true;
            break;
          }
        }
      }
    }
    return flag;
  }

  // 第二列标题
  @computed
  get col2Title() {
    const { isDiscountMode, isActivityMode } = this;
    if (isDiscountMode && !this.isShopMasterMode && !isActivityMode) {
      return '折扣';
    }
    return '配货比例';
  }

  // 第二列数据
  @computed
  get col2List() {
    const {
      proportionType // 0:默认1:1 1:自定义配货比
    } = Stores.AppMod.userInfo;
    let col2 = {};
    if (this.isShopMasterMode) {
      col2 = this.shopMasterDistributionRatio;
    } else {
      // 秒杀拼团预售走配货比例模式
      if (this.isDiscountMode && !this.isActivityMode) {
        if (!this.productInfo.allowDiscount) {
          col2 = null;
        } else {
          col2 = this.discountList;
        }
      } else {
        col2 = this.distributionRatioList;
      }
    }
    // 甄选商城 自定义配货比
    if (this.isFromSelectMall) {
      const list = toJS(Stores.AppMod.userInfo.distributionRatioList || []);
      const subList = list && Array.isArray(list[1]) ? list[1] : [];
      col2 = { 30: proportionType === 1 ? subList : [] };
    }
    return col2;
  }

  // 第二列字段名
  @computed
  get col2Params() {
    let name = 'orderProperty';
    if (!this.isShopMasterMode) {
      if (this.isDiscountMode) {
        name = 'discount';
      }
    }
    return name;
  }

  @computed
  get bannerList() {
    let list = [];

    if (this.activityInfo && this.activityInfo.mainPic) {
      try {
        let arr = JSON.parse(this.activityInfo.mainPic);
        if (arr.length > 0) {
          list = list.concat({ path1: arr[0], fileType: 1 });
        }
      } catch (err) {
        console.log('mainPic解析失败', err);
      }
    }

    if (this.productInfo) {
      list = list.concat(toJS(this.productInfo.mediaRespDtoList) || []);
    }
    return list;
  }

  // 获取默认的赠品
  @action
  getDefaultGiftList() {
    const { defaultActivityList, bizDefaultGiveawayReqDto } = this;
    const { freeItem = [], giftList = [] } = bizDefaultGiveawayReqDto || {};
    if (Array.isArray(toJS(defaultActivityList)) && defaultActivityList.length > 0) {
      let idList = [];
      defaultActivityList.forEach((item) => {
        const { activityId } = item;
        idList = [...idList, activityId];
      });
      this.getdefaultActivityGiftList(idList.join(',')).then((res) => {
        if (res) {
          const freeItemList = [...freeItem, ...res.giftItems];
          const giftListList = [...giftList, ...res.couponRightsList];
          let newObject = {
            freeItem: freeItemList,
            giftList: giftListList
          };
          this.changeState({ bizDefaultGiveawayReqDto: newObject });
        }
      });
    }
  }

  /**
   * 获取产品详情
   */
  getProductDetail = flow(function* (data) {
    let productId = data ? data : this.productId;
    if (this.isBean) {
      productId = this.beanItemId;
    }
    this.loadingProductInfo = true;
    try {
      const { data, resultCode } = yield Serv.getProductDetail(
        // this.productId,
        productId,
        this.type
      );
      if (data) {
        if (!this.activityAppDownloadGuide) {
          this.appDownloadGuide = data.appDownloadGuide;
        }
        const productInfo = data;
        console.log('1产品详情吗=======', productInfo);
        if (productInfo.type == 6) {
          this.getMoreMultiList(productInfo.id);
        }
        // this.distributionRatioMap = JSON.parse(data.propertiesDistributionRatios);

        // 调用浏览足迹的接口
        Stores.AppMod.token && this.addFootPrint(this.productId);

        // 图文详情
        if (data.detail) {
          let remDetail = '';

          try {
            const detailObj = JSON.parse(data.detail);
            remDetail =
              `${detailObj.tick}` == '1' || detailObj.tick == true ? detailObj.pc : detailObj.h5;
          } catch (error) {}

          if (remDetail) {
            // 处理图文详情信息，将px转成rem
            remDetail = Util.changeRichText(remDetail);
            // 处理图片
            // productInfo.detail = Util.replaceOssParams(remDetail, 750);
            productInfo.detail = remDetail;
          } else {
            productInfo.detail = '';
          }
        }

        this.productInfo = productInfo;
        this.itemNum = 1;
        if (productInfo.minNumber) {
          this.itemNum = productInfo.minNumber;
        }
        if (productInfo.minSaleNum) {
          this.itemNum = productInfo.minSaleNum;
        }
        if (productInfo.questionStatus == 1) {
          this.getQuestionList();
        }
        // 已下架 产品黑名单逻辑
        this.getBlackItemActivityIdList();
        this.getEvaluateList();
        this.getProductSellPoint();

        // 获取是否收藏
        this.checkIsCollected();
        // 获取推荐产品列表
        this.getRecommendList();
        // 获取推荐产品列表
        this.getRecommendBundles();
        // 查询产品搜索优化信息
        this.getSearchOpt();
        // 查询活动列表
        this.getPromoteInfo();
        //未登录、已包邮、秒杀、拼团、预售、精选不显示地址，无需请求接口
        if (Stores.AppMod.token && !this.activityId && !this.isFromSelectMall) {
          this.getAddressList();
        }

        console.log('routerRedirect');
        !this.isFromSelectMall &&
          setTimeout(() => {
            this.getActivityList(false, null, true);
          }, 500);
        this.handleOrderTypeAndRatio();

        this.getShareId().then(() => {
          this.initShare();
        });

        // 神策数据发送
        window.sensors.track('viewCommodity', {
          commodity_id: data.id,
          commodity_name: `${data.code || ''}-${data.name || ''}`,
          price: data.price,
          source: 'H5' // 来源
        });

        if (this.isBean) {
          const { userInfo } = Stores.AppMod;
          window.sensors.track('itemBrowsing', {
            commodity_id: data.id,
            commodity_name: `${data.code || ''}-${data.name || ''}`,
            userId: userInfo.id,
            cardCode: userInfo.cardCode || '',
            source: 'H5', // 来源
            scene: '三生豆商城'
          });
        }

        if (Stores.AppMod.userType >= 2 && productInfo.vitrual) {
          // 允许负库存下单
          this.limitNum = 9999;
          this.hasRequestStock = true;
        } else {
          // 获取库存
          this.productInfo.type != 6 && this.getInventory();
          if (this.productInfo.type == 6) {
            this.limitNum = 9999;
            this.hasRequestStock = true;
          }
        }
        // 初始化默认配货比例
        if (Object.keys(this.discountList).length > 0) {
          this.orderProperty = 1;
          if (productInfo.allowDiscount == 1) {
            this.handleDiscount();
          } else {
            this.discount = 1;
          }
        } else {
          this.orderProperty = '1';
        }
        const {
          proportionType // 0:默认1:1 1:自定义配货比
        } = Stores.AppMod.userInfo;
        // 甄选商城 自定义配货比  默认选中配高的
        if (this.isFromSelectMall) {
          if (proportionType === 1) {
            const list = toJS(Stores.AppMod.userInfo.distributionRatioList || []);
            const subList = list && Array.isArray(list[1]) ? list[1] : [];
            if (subList.length > 1) {
              const maxItem = subList.reduce(
                (max, item) => (Number(item.value) > Number(max.value) ? item : max),
                subList[0]
              );
              this.orderProperty = maxItem.value || '';
            }
          }
        }

        // this.getActivityList(false, null, true);
        // this.getActivityList().finally(() => {
        //   this.getDefaultGiftList();
        // });
        const { userInfo, token } = Stores.AppMod;

        if (token) {
          const { belongSystem } = userInfo;
          if (belongSystem == 'KER') {
            Stores.AppMod.setKerUpdateHealth(); // 可儿玫瑰更新健康顾问
          }
        }
      }
      if (resultCode == '5000') {
        this.unable = true;
      }
    } catch (error) {
      console.log(error, '---error wechat login--->');
      this.hasRequestStock = true;
    }
    this.loadingProductInfo = false;
  });

  /**
   * 获取问答列表
   */
  getQuestionList = flow(function* () {
    try {
      const { data } = yield Serv.getQuestionList(this.productId);
      if (data) {
        this.questionList = data || [];
      }
    } catch (error) {
      console.log(error);
    }
  });

  getBlackItemActivityIdList = flow(function* () {
    try {
      const { data } = yield Serv.getBlackItemActivityIdList(this.productId);
      if (data) {
        this.blackActList = data;
      }
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 获取评价列表
   */
  getEvaluateList = flow(function* () {
    try {
      const { data } = yield Serv.getEvaluateList(this.productInfo.code);
      if (data) {
        this.evaluateList = data || {};
      }
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 浏览足迹
   */
  addFootPrint = flow(function* (id) {
    try {
      const { data } = yield Serv.addFootPrint(this.productId);
      console.log('🤬data');
    } catch (e) {}
  });

  /**
   * 处理订单类型和配货比例
   * @param {boolean} ignoreOrderType - 是否忽略计算订单类型
   */
  @action
  handleOrderTypeAndRatio(ignoreOrderType) {
    console.log('handleOrderTypeAndRatio');

    // 没有登录的时候，不需要走以下逻辑，否则会抛错误
    if (!Stores.AppMod.token) {
      return;
    }

    let orderTypes = '';
    let distributionRatios = '';
    const { activityType, orderType, allocateCargoScale } = this.activityInfo || {};
    const { itemProperties, propertiesDistributionRatios } = this.productInfo || {};
    let distributionRatio = JSON.parse(propertiesDistributionRatios || '{}')[this.orderType];
    // orderType 0：所有，1：零售单，2：复消订单
    // allocateCargoScale 支持配货比例，0：所有，1：1:1配货，2：1:2配货，3：1:3配货

    if (this.activityId) {
      if (this.productInfo && this.activityInfo) {
        if (this.activityInfo.activityStatus != 5) {
          if (!+orderType) {
            orderTypes = '1, 2';
          } else {
            orderTypes = `${orderType}`;
          }
          // 非资格购需要取交集
          if (activityType != 10) {
            orderTypes = getArrEqual(
              orderTypes ? orderTypes.split(',') : [],
              itemProperties ? itemProperties.split(',') : []
            ).join(',');
            distributionRatios = getArrEqual(
              allocateCargoScale || [],
              distributionRatio ? distributionRatio.split(',') : []
            ).join(',');
          } else {
            distributionRatios = distributionRatio;
          }
        } else {
          // 取普通的
          orderTypes = itemProperties;
          distributionRatios = distributionRatio;
        }
      }
    } else {
      // 取普通的
      // itemProperties：5-小优云健康 4-物料产品 3-扣款蓄水池产品 2-复消订单产品 1-零售订单产品
      orderTypes = itemProperties === '5' ? '1' : itemProperties;
      distributionRatios = distributionRatio;
    }

    // 是否需要重新计算订单类型

    if (!ignoreOrderType) {
      const { userType, userInfo } = Stores.AppMod;
      let orderTypeList = [];

      // // 处理订单类型
      // let orderTypeList = [{value: '1', label: orderLabelList[0] && orderLabelList[0].label || '零售订单'}];
      // // 资格购放开复消订单类型
      // if (userType != 1) {
      //   if(orderLabelList.length === 2 && orderLabelList[1] && orderLabelList[1].value){
      //     orderTypeList = orderTypeList.concat([
      //       {value: '2', label: orderLabelList[1] && orderLabelList[1].label || '复消订单'},
      //     ]);
      //   }

      // }
      if (userType != 1) {
        orderTypeList = userInfo.orderLabelList;
      } else {
        orderTypeList = userInfo.orderLabelList.filter((v) => v.value != '2');
      }
      if (orderTypes) {
        for (let i = orderTypeList.length - 1; i >= 0; i--) {
          if (orderTypes.indexOf(`${orderTypeList[i].value}`) == -1) {
            const v = cloneDeep(toJS(orderTypeList));
            v.splice(i, 1);
            orderTypeList = v;
          }
        }
      } else {
        orderTypeList = [];
      }
      if (orderTypeList.length > 0 && !this.orderType) {
        this.orderType = orderTypeList[0].value;
      }
      // console.log('isFromSelectMallsssd', this.isFromSelectMall);
      // console.log('uuiop', toJS(orderTypeList));
      // console.log('uuiop2', toJS(userInfo.orderLabelList));
      this.orderTypeList = orderTypeList;
      const {
        proportionType // 0:默认1:1 1:自定义配货比
      } = Stores.AppMod.userInfo;
      if (this.isFromSelectMall) {
        this.orderTypeList = [{ value: '30', label: '甄选订单' }];
      }
      if (orderTypeList.length === 1) {
        this.orderType = JSON.parse(JSON.stringify(orderTypeList[0].value));
      }
    }
    // if(Stores.AppMod.userInfo.distributionRatioList){
    // 处理配货比例（取后台返回的配货比例）
    const userInfoObj = Util.getLocalCache(Config.localStorageKeys.member_userInfo);
    console.log(userInfoObj, '-----userInfo', toJS(Stores.AppMod.userInfo.distributionRatioList));
    let oldList =
      toJS(Stores.AppMod.userInfo.distributionRatioList) || userInfoObj.distributionRatioList;
    // oldList &&
    //   Object.keys(oldList).forEach((item) => {
    //     oldList[item].shift();
    //   });
    let newList = oldList || [];
    if (distributionRatios) {
      Object.keys(newList).forEach((item) => {
        for (let i = newList[item].length - 1; i >= 0; i--) {
          if (distributionRatios.indexOf(`${newList[item][i].value}`) == -1) {
            const v = cloneDeep(toJS(newList[item]));
            v.splice(i, 1);
            newList[item] = v;
          }
        }
      });
    } else {
      // newList = [];
      newList = {};
    }
    if (newList.length > 0) {
      const item = newList.find((item) => {
        const { orderMinAmount } = item;
        if (orderMinAmount > 0) {
          if (this.itemNum * this.productInfo.price > orderMinAmount) {
            return true;
          }
          return false;
        }
        return true;
      });
      this.orderProperty = item ? item.value : '';
    }
    // 资格购取并集
    if (activityType == 10 && `${allocateCargoScale}`) {
      if (!newList['1']) {
        newList['1'] = [];
      }
      if (!newList['2']) {
        newList['2'] = [];
      }
      let list_1 = newList['1'].map((item) => item.value);
      let list_2 = newList['2'].map((item) => item.value);
      allocateCargoScale.forEach((_val) => {
        newList['1'].find((item) => item);
        if (!list_1.includes(`${_val}`)) {
          newList['1'].push({
            label: `1:${_val} 配货`,
            value: `${_val}`
          });
        }
        if (!list_2.includes(`${_val}`)) {
          newList['2'].push({
            label: `1:${_val} 配货`,
            value: `${_val}`
          });
        }
      });
      newList['1'].sort((pre, next) => next.value - pre.value);
      newList['2'].sort((pre, next) => next.value - pre.value);
    }

    // 资格购配置配货比例可跨越用户支持配货比例下单，则直接用资格购的配货比例
    if (activityType == 10 && `${allocateCargoScale}` && this.cargoScalePriorityTag) {
      const supportCargoScale = allocateCargoScale.map((_val) => ({
        label: `1:${_val} 配货`,
        value: `${_val}`
      }));
      supportCargoScale.sort((pre, next) => next.value - pre.value);
      if (newList['1']) {
        newList['1'] = supportCargoScale;
      }
      if (newList['2']) {
        newList['2'] = supportCargoScale;
      }
      this.orderProperty = Math.max(...(allocateCargoScale || [])) + '';
    }

    // const { isLD } = Stores.AppMod;
    // if (isLD && newList['2']) {
    //   newList['2'] = newList['2'].filter((item) => item.value < 2);
    // }
    console.log(newList, '------->');
    // 当只有一种配货比例，默认选中
    setTimeout(() => {
      if (newList[this.orderType] && newList[this.orderType].length == 1) {
        runInAction(() => {
          this.orderProperty = newList[this.orderType][0].value;
        });
      }
      // 非甄选商城订单，默认选中1:1配货 (甄选商城默认选中最高比例 已处理)
      if (!this.isFromSelectMall && newList[this.orderType] && newList[this.orderType].length > 1) {
        runInAction(() => {
          this.orderProperty = 1;
        });
      }
      // 【前端 | H5】钻卡用户在选择商品的时候能优先识别1:2配货
      if (
        Stores.AppMod.userInfo.cardType == 3 &&
        Stores.AppMod.userInfo.systemType == 0 &&
        newList[this.orderType] &&
        newList[this.orderType].find((v) => v.value == 2)
      ) {
        console.log(newList[this.orderType], '---->CCCCC');
        runInAction(() => {
          this.orderProperty = 2;
        });
      }
      if (newList[this.orderType] && newList[this.orderType].length == 1) {
        runInAction(() => {
          this.orderProperty = newList[this.orderType][0].value;
        });
      }

      if (activityType == 10 && `${allocateCargoScale}` && this.cargoScalePriorityTag) {
        runInAction(() => {
          this.orderProperty = Math.max(...(allocateCargoScale || [])) + '';
        });
      }
    });
    this.distributionRatioList = newList;
    // }
  }

  /**
   * 处理折扣比例，根据接口返回设置
   */
  @action
  handleDiscount(reset = false) {
    if (!this.discount || reset) {
      if (this.isDiscountMode) {
        this.discount = this.discountList[this.orderType][0].value;
        this.orderProperty = 1;
      } else {
        this.orderProperty = '';
      }
    }
  }

  /**
   * 获取库存
   */
  getInventory = flow(function* () {
    if (!this.productInfo.code) {
      this.hasRequestStock = true;
      return;
    }

    try {
      const { data } = yield Serv.getInventory({
        cargoId: this.productId,
        cargoCode: this.productInfo.code
      });
      if (data) {
        this.limitNum = data.availableNum;
      }
    } catch (error) {}
    this.hasRequestStock = true;
  });

  /**
   * 获取推荐产品
   */
  getRecommendList = flow(function* () {
    const itemId = this.productInfo.id;
    // Stores.AppMod.token
    // 二期大数据版本，即使未登录，也要请求推荐商品
    if (!itemId) {
      return;
    }
    try {
      const { data } = yield Serv.getRecommendList(itemId);
      this.recommendList = data || [];
    } catch (error) {}
  });

  /**
   * 获取推荐组合产品
   */
  getRecommendBundles = flow(function* () {
    if (!this.productInfo.code) {
      return;
    }
    try {
      const { data } = yield Serv.getRecommendBundles(this.productInfo.code);
      const bundleList = data || [];
      this.bundleList = bundleList.filter((item) => {
        return `${item.status}` == '1';
      });
    } catch (error) {}
  });

  /**
   * 查询产品搜索优化信息
   */
  getSearchOpt = flow(function* () {
    if (!this.productInfo.code) {
      return;
    }
    try {
      const { data } = yield Serv.getSearchOpt(this.productInfo.code);
      this.setSearchOpts(data);
    } catch (error) {}
  });

  /** 设置SEO header属性 */
  setSearchOpts(data) {
    const { pageKeywords = '', pageDescription = '', pageTitle = '' } = data;

    const keywordsMeta = window.document.querySelector('meta[name="keywords"]');
    keywordsMeta.setAttribute('content', pageKeywords);
    const DscMeta = window.document.querySelector('meta[name="description"]');
    DscMeta.setAttribute('content', pageDescription);
    if (pageTitle) {
      window.document.title = pageTitle;
    }
  }

  /**
   * 查询是否已收藏
   */
  checkIsCollected = flow(function* (productId = '') {
    if (!Stores.AppMod.token) {
      return false;
    }
    try {
      const { data } = yield Serv.checkIsCollected(productId || this.productId, this.activityId);
      this.isCollected = !!data;
      this.realCollected = !!data;
      return !!data;
    } catch (error) {}
  });

  checkReload = (timeCount) => {
    const countTime = setInterval(() => {
      timeCount--;
      if (
        timeCount == 0 &&
        Object.keys(this.promoteInfo).length < 1 &&
        this.getActiveList.length < 1
      ) {
        clearInterval(countTime);
        Modal.alert('', '获取活动信息超时，是否刷新当前页面？', [
          { text: '取消' },
          {
            text: '确定',
            onPress: () => {
              window.location.reload();
            }
          }
        ]);
      }
    }, 1000);
  };

  /**
   * 查询当前商品可参与的促销活动列表信息
   */
  getPromoteInfo = flow(function* () {
    // 资格购活动需要过滤，其需要请求促销活动列表
    if ((![10].includes(+this.activityType) && this.activityId) || !Stores.AppMod.token) {
      this.promoteInfo = { key: '' };
      return;
    }
    try {
      this.checkReload(10);
      let result = '';

      if (this.isBean) {
        result = yield Serv.getBeanPromoteInfo(this.productId, this.globalSaleMode);
      } else if (this.isPriaItem) {
        result = yield Serv.getPriaPromoteInfo(this.productId, this.globalSaleMode);
      } else {
        result = yield Serv.getPromoteInfo(
          this.productId,
          this.source,
          this.activityId,
          this.globalSaleMode
        );
      }

      const data = result.data;
      if (data) {
        // 非资格购进来页面，需要过滤掉资格购活动
        // if (data.activityBaseInfoRespDtoList && this.activityType != 10) {
        //   data.activityBaseInfoRespDtoList = data.activityBaseInfoRespDtoList.filter(
        //     item => item.activityType == 6,
        //   );
        // }
        this.promoteInfo = data;
        if (!this.activityId && this.activityType != 10) {
          let tmpArr = data.activityBaseInfoRespDtoList || [];
          let newArr = tmpArr.filter((item) => {
            // 此处的资格购活动标签，是6
            return item && item.activityType != 6;
          });
          this.promoteInfo.activityBaseInfoRespDtoList = newArr;
        }
      } else {
        this.promoteInfo = { key: '' };
      }
    } catch (error) {
      this.promoteInfo = { key: '' };
    }
  });

  /**
   * 赠品去结算数据出来
   * list {} 已选赠品
   */
  handleGiftSettle = (list, activityIdList, groupKey, giftListActivity) => {
    let giftList = [];
    if (list && isArray(list) && list.length > 0 && list[0].length > 0) {
      list.forEach((giftArray, ind) => {
        let { giftType } = giftArray[0] || {};
        let items = [];
        // 实物赠品
        giftArray &&
          !!giftArray.length &&
          giftArray.forEach((item, index) => {
            const effectiveType =
              item.resolvedGiftType !== undefined ? item.resolvedGiftType : +giftType;
            // 如果是多规格 则取已选择的子商品
            const _checkItem =
              item.subGiftItemSelectRespDtoList &&
              item.subGiftItemSelectRespDtoList.find((ele) => ele.isSelected);
            if (+effectiveType === 1 && +item.presentWay !== 3) {
              items.push({
                viewId: '',
                itemName: _checkItem ? _checkItem.itemName : item.itemName,
                itemNum: item.giftCount,
                itemPrice: _checkItem ? _checkItem.price : item.price,
                itemSerial: _checkItem ? _checkItem.itemSerial : item.itemSerial,
                skuSerial: _checkItem ? _checkItem.skuSerial : item.skuSerial,
                $activityId: giftListActivity[ind],
                activityIdList: [giftListActivity[ind]],
                groupKey
              });
            } else if (+effectiveType === 1 && +item.presentWay === 3) {
              if (item.subGiftItemSelectRespDtoList) {
                item.subGiftItemSelectRespDtoList.map((subItem) => {
                  if (subItem.itemSelectNum > 0) {
                    items.push({
                      viewId: '',
                      itemName: subItem.itemName,
                      itemNum: subItem.itemSelectNum,
                      itemPrice: subItem.price,
                      itemSerial: subItem.itemSerial,
                      skuSerial: subItem.skuSerial,
                      activityIdList: giftListActivity[ind],
                      groupKey
                    });
                  }
                });
              } else if (item.itemSelectNum > 0) {
                items.push({
                  viewId: '',
                  itemName: item.itemName,
                  itemNum: item.itemSelectNum,
                  itemPrice: item.price,
                  itemSerial: item.itemSerial,
                  skuSerial: item.skuSerial,
                  activityIdList: giftListActivity[ind],
                  groupKey
                });
              }
            }
          });
        // 权益赠品
        giftArray &&
          !!giftArray.length &&
          giftArray.forEach((item) => {
            const effectiveType =
              item.resolvedGiftType !== undefined ? item.resolvedGiftType : +giftType;
            const _checkItem =
              item.subGiftItemSelectRespDtoList &&
              item.subGiftItemSelectRespDtoList.find((ele) => ele.isSelected);
            if (+effectiveType === 2 || +effectiveType === 3) {
              items.push({
                giftType: effectiveType,
                itemName:
                  effectiveType == 2
                    ? _checkItem
                      ? _checkItem.couponName
                      : item.couponName
                    : _checkItem
                      ? _checkItem.rightsName
                      : item.rightsName,
                itemNum: item.giftCount,
                giftId: _checkItem ? _checkItem.id : item.id,
                giftNum: item.giftCount,
                activityIdList: [giftListActivity[ind]],
                groupKey
              });
            }
          });
        const entityItems = items.filter((i) => !i.giftType || i.giftType === 1);
        const couponItems = items.filter((i) => i.giftType === 2 || i.giftType === 3);
        if (entityItems.length) giftList.push({ giftType: 1, items: entityItems });
        if (couponItems.length) giftList.push({ giftType: 2, items: couponItems });
      });
    }
    if (!this.flashSaleFullToGiveSuperpositionTag && this.activityType == 9) {
      return [];
    }
    return giftList;
  };

  getListParam = (filter) => {
    let giftItems = []; // 存放所有已选的实物赠品
    let couponRightsList = []; // 存放所有已选的赠券和赠权益
    const { id, price, skuId } = this.productInfo;
    const { activityType, activityList, activityInfo = {}, giftListActivity } = this;
    let groupKey = 0;
    let activityIdList = [];
    console.log('activityIdactivityIds', this.activityId);

    if (activityType != 10 && activityType != 12 && this.activityId) {
      // 秒杀团购预售
      groupKey = 1024;
      activityIdList = [this.activityId];
      if (activityType == '9') {
        if (activityList && activityList.length > 0) {
          for (let i = 0; i < activityList.length; i++) {
            const { activityBaseInfoList } = activityList[i];
            for (let j = 0; j < toJS(activityBaseInfoList).length; j++) {
              const { selected, activityId } = toJS(activityBaseInfoList)[j];
              if (selected) {
                if (activityId) {
                  activityIdList.push(activityId);
                  groupKey = 1024;
                }
              }
            }
          }
        }
      }
    } else {
      if (activityList && activityList.length > 0) {
        for (let i = 0; i < activityList.length; i++) {
          const { activityBaseInfoList } = activityList[i];
          for (let j = 0; j < toJS(activityBaseInfoList).length; j++) {
            const { selected, activityId } = toJS(activityBaseInfoList)[j];
            if (selected) {
              if (activityId) {
                activityIdList.push(activityId);
                groupKey = 1024;
              }
            }
          }
        }
      }
      // else {
      //   if (activityType == 10 && this.activityId) {
      //     activityIdList.push(this.activityId);
      //     groupKey = 1024;
      //   }
      // }
    }
    this.defaultActivityList.forEach((item) => {
      const { activityId } = item;
      activityIdList.push(activityId);
    });
    const itemNum =
      (this.itemNum || 1) >= (this.itemMinBuy || 1) ? this.itemNum || 1 : this.itemMinBuy;
    const items = [
      {
        itemNum,
        itemPrice: price,
        itemSerial: id,
        skuSerial: skuId,
        activityIdList,
        groupKey
      }
    ];
    // 如果是拼团、预售、秒杀活动（7 <= activityType <= 10）
    const { activityId, itemId } = activityInfo || {};
    if (activityType >= 7 && activityType <= 9 && activityId) {
      items[0].groupKey = 1024;
    }

    // 判断是否是生日的代客下单
    this.checkBirthdayPay();
    let bizGiveawayReqDto = {};
    this.handleSelectedGiftList();
    if (this.giftActId) {
      let it = this.handleGiftSettle(
        toJS(this.selectedGiftList),
        activityIdList,
        groupKey,
        giftListActivity
      );
      for (const item of it) {
        if (item.giftType == 1) {
          giftItems = [...giftItems, ...item.items];
        } else {
          couponRightsList = [...couponRightsList, ...item.items];
        }
      }

      if (this.activityInfo) {
        Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          activityInfo: this.activityInfo
        });
      }
      bizGiveawayReqDto = {
        giftType: it.giftType,
        freeItem: giftItems,
        giftList: couponRightsList
      };
    }
    const { bizDefaultGiveawayReqDto } = this;
    if (Object.keys(toJS(bizDefaultGiveawayReqDto)).length > 0) {
      let { freeItem = [], giftList = [] } = bizGiveawayReqDto || {};
      const { freeItem: newFreeItem, giftList: newGiftList } = toJS(bizDefaultGiveawayReqDto) || {};
      freeItem = [...freeItem, ...newFreeItem];
      giftList = [...giftList, ...newGiftList];
      bizGiveawayReqDto = { ...bizGiveawayReqDto, freeItem, giftList };
    }
    if (this.incPriceId) {
      let cheapItems = this.incPriceList
        .filter((item) => item.itemNum > 0 && this.selectedGiftItems[item.itemId])
        .map((item) => {
          // 加价购商品如果是sku子项 则传已选择的子项信息
          const _checkItem =
            item.subGiftItemSelectRespDtoList &&
            item.subGiftItemSelectRespDtoList.find((ele) => ele.isSelected);
          return {
            activityId: item.activityId,
            activityIdList,
            $activityId: item.activityId,
            groupKey: 1024,
            itemNum: item.itemNum || 0,
            itemPrice: _checkItem ? _checkItem.price : item.salePrice,
            itemSerial: _checkItem ? _checkItem.itemSerial : item.itemId,
            skuSerial: _checkItem ? _checkItem.skuSerial : item.skuId
          };
        });
      bizGiveawayReqDto.cheapItem = cheapItems;
    }

    // 过滤盲盒活动的赠品
    if (filter) {
      const arrays = ['cheapItem', 'freeItem'];
      arrays.forEach((key) => {
        if (bizGiveawayReqDto[key]) {
          bizGiveawayReqDto[key] = bizGiveawayReqDto[key].filter((o) => {
            const target = activityList.find((a) =>
              (a.activityBaseInfoList || []).find(
                (t) => t.activityId === o.$activityId && t.random == 1
              )
            );
            if (target) return false;
            return true;
          });
        }
      });
    }
    // 甄选商品 不需要活动相关信息
    if (this.isFromSelectMall) {
      items.forEach((val) => {
        val.activityIdList = [];
        val.groupKey = '0';
      });
      bizGiveawayReqDto = {};
    }

    return { items, bizGiveawayReqDto };
  };
  /**
   * suport1to2 是否支持1：2
   */
  @action
  goCheckOrder(sign, ment, activityLink, addActivityId, suport1to2, extra) {
    const { id: userId } = Stores.AppMod.userInfo || {};
    const { allowDiscount, type } = this.productInfo;
    const {
      activityType,
      orderTypeList,
      distributionRatioList,
      isVipRebuy,
      activityInfo = {},
      isPriaItem
    } = this;
    const { preSellType } = this.activityInfo || {};
    if (orderTypeList.length == 0 || distributionRatioList.length == 0) {
      Toast.info('该产品不支持购买');
      return;
    }

    if (!this.orderType) {
      Toast.info('请先选择订单类型');
      return;
    }
    if (!this.orderProperty) {
      Toast.info('请先选择配货比例');
      //甄选商城订单
      return;
    }

    const { items, bizGiveawayReqDto } = this.getListParam(true);
    const { activityId, itemId } = activityInfo || {};

    let params = {
      items,
      activityType,
      itemId, // 商品id
      activityId, // 活动id
      orderType: isVipRebuy ? 10 : this.orderType,
      orderProperty: this.orderProperty,
      bizGiveawayReqDto,
      isVipRebuy,
      isShopMasterMode: this.isShopMasterMode,
      isSelectMall: this.isFromSelectMall,
      // 支持1；2 且 不是虚拟产品 3 虚拟组合产品 4 虚拟产品
      suport1to2: suport1to2 && ![3, 4].includes(type),
      ...extra
    };
    // 新增折扣信息
    if (this.isDiscountMode && !this.isActivityMode) {
      params.discount = allowDiscount ? this.discount : 1;
      params.orderProperty = 1;
    }
    if (this.isShopMasterMode) {
      params.discount = this.discount;
      params.orderProperty = this.orderProperty;
    }

    //甄选商城订单
    if (this.isFromSelectMall) {
      // params.orderProperty = 1;
      params.orderProperty = this.orderProperty;
      params.orderType = 30;
      params.bizGiveawayReqDto = {};
    }

    if (this.inletTitle) {
      params.inletTitle = this.inletTitle;
    }
    if (this.sourceTag) {
      params.sourceTag = `${this.sourceTag}-商品详情`;
    }
    if (this.invitationUserId) {
      params.invitationUserId = this.invitationUserId;
    }

    //三生豆订单
    if (this.isBean) {
      items.forEach((item) => {
        item.beanItemSerial = item.itemSerial;
        item.beanNum = this.productInfo.beanNum;
      });
      params.beanItems = items;
      //置标志位
      Stores.CheckOrderMod.isBean = true;
    }
    const $sign = ![advanceSaleTypeMap.DEPOSITSALE, advanceSaleTypeMap.FULLPAYMENT].includes(
      preSellType
    );
    params.multiActivityValidateFlag = $sign;

    params.productDetailMod = this;
    // 判断是否是团长免单
    let getInfo = +this.autoComplete === 2 ? 'autoComplete' : '';
    this.showSpecModal = false;
    if (this.addressInfo && this.addressInfo.id) {
      Stores.CheckOrderMod.changeState({ defaultAddressInfo: this.addressInfo });
    }
    if (isPriaItem) {
      items.forEach((item) => {
        item.beanItemSerial = 0;
        item.beanNum = this.productInfo.beanNum;
        item.itemSerial = this.productInfo.itemId;
      });
      params.beanItems = items;
      params.orderType = 1;
      params.orderProperty = 1;
      params.isPriaItem = true;
    }
    Stores.CheckOrderMod.confirmOrder(
      params,
      getInfo,
      sign || 'showProductTip',
      { hideOrderTypeListAndDiscountMode: this.hideOrderTypeListAndDiscountMode },
      true,
      ment,
      activityLink,
      addActivityId
    );
  }

  /**
   * 生日下单的校验
   */
  checkBirthdayPay = () => {
    const { memberCard, memberName, memberId, birthday } = this.dgInfo || {};
    Stores.CheckOrderMod.changeState({ birthday });
    if (memberCard && memberName) {
      Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
        dgMemberInfo: {
          memberCard,
          memberName,
          origin: 'shop' // 代客来源，默认店铺代客shop、会员代客member
        },
        dgUserId: memberId,
        dgCardCode: memberCard
      });
    }
  };

  /**
   * 预售尾款 直接确认订单
   */
  goCheckOrderAdvanceSaleTail(params) {
    Stores.CheckOrderMod.confirmOrder(params);
  }

  /**
   * @description 获取分享链接
   */
  getShareLinkUrl = async () => {
    const { phone } = Stores.AppMod.userInfo || {};

    const userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
    let userId = '';
    let cardCode = '';
    if (userInfo) {
      userId = userInfo.id;
      cardCode = userInfo.cardCode;
    }
    if (userId) {
      let { href } = window.location;
      let isLY = sessionStorage.getItem('systemCode') == 'LY' || Stores.AppMod.isLY;
      let p = phone;
      if (!Stores.BusinessCard.info.id) {
        await Stores.BusinessCard.getCardInfo();
      }
      if (Stores.BusinessCard.info.phone && Stores.BusinessCard.info.phone.indexOf('*') != -1) {
        let newInfo = { ...Stores.BusinessCard.info };
        if (!Stores.BusinessCard.decyptInfo.phone) {
          let decyptPhone = await Stores.AppMod.getDecyptMsg({
            scene: 224,
            id: Stores.BusinessCard.info.id,
            channal: ''
          });
          Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
            decyptInfo: { ...Stores.BusinessCard.decyptInfo, phone: decyptPhone }
          });
          await Stores.BusinessCard.changeState({
            decyptInfo: { ...Stores.BusinessCard.decyptInfo, phone: decyptPhone },
            isSecret: false
          });
          newInfo.phone = decyptPhone;
        } else {
          newInfo.phone = Stores.BusinessCard.decyptInfo.phone;
        }
        if (!Stores.BusinessCard.decyptInfo.name) {
          let decyptName = await Stores.AppMod.getDecyptMsg({
            scene: 125,
            id: Stores.BusinessCard.info.id,
            channal: ''
          });
          Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
            decyptInfo: { ...Stores.BusinessCard.decyptInfo, name: decyptName }
          });
          await Stores.BusinessCard.changeState({
            decyptInfo: { ...Stores.BusinessCard.decyptInfo, name: decyptName }
          });
          newInfo.name = decyptName;
        } else {
          newInfo.name = Stores.BusinessCard.decyptInfo.name;
        }

        await Stores.BusinessCard.changeState({
          info: newInfo
        });
      }
      // 假如是二次分享的话，这种拼接是会有问题的，相当于拼接了两个以上share_user_id
      if (href.includes('share_user_id') || href.includes('cardCode')) {
        let arr = href.split('&');
        arr.forEach((item, i) => {
          if (item.includes('share_user_id') || item.includes('cardCode')) {
            arr[i] = '';
          }
        });
        this.shareLink = `${arr.join('&')}&share_user_id=${userId}&cardCode=${cardCode}${
          isLY
            ? '&systemCode=LY'
            : '&name=' +
              encodeURIComponent(Stores.BusinessCard.info.name) +
              '&phone=' +
              (p || Stores.BusinessCard.info.phone)
        }&subActivityId=${
          sessionStorage.getItem('subActivityId') || ''
        }&subActivityChannel=${sessionStorage.getItem('subActivityChannel')}`;
      } else {
        let res = href.indexOf('?') != -1 ? href + '&' : href + '?';
        this.shareLink = `${res}share_user_id=${userId}&cardCode=${cardCode}${
          isLY
            ? '&systemCode=LY'
            : '&name=' +
              encodeURIComponent(Stores.BusinessCard.info.name) +
              '&phone=' +
              Stores.BusinessCard.info.phone
        }&subActivityId=${
          sessionStorage.getItem('subActivityId') || ''
        }&subActivityChannel=${sessionStorage.getItem('subActivityChannel')}`;
      }

      if (this.shareId) {
        this.shareLink = Util.replaceQueryParam(this.shareLink, 'shareId', this.shareId);
      }
      if (cardCode) {
        this.shareLink = Util.replaceQueryParam(this.shareLink, 'cardCode', cardCode);
        if (this.shareLink.includes('bindCardCode')) {
          this.shareLink = Util.replaceQueryParam(this.shareLink, 'bindCardCode', cardCode);
        }
      }
      if (this.invitationUserId) {
        this.shareLink = Util.replaceQueryParam(this.shareLink, 'invitationUserId', userId);
      }
    }
    if (this.shareLink) {
      if (Stores.AppMod.isTeamShareFlag) {
        let res = this.shareLink.indexOf('?') != -1 ? this.shareLink + '&' : this.shareLink + '?';
        let fromTeamShareFlag = await Stores.AppMod.getAutoSortResult();
        if (fromTeamShareFlag) {
          this.shareLink = res + `fromTeamShareFlag=${fromTeamShareFlag}`;
        }
      }
    }
  };

  /**
   * 初始化微信分享配置
   */
  initShare = flow(async function* () {
    const { shareCardTitle, shareSubTitle } = (this.activityDetail || {}).baseReqDto || {};
    const { name, id, mediaRespDtoList } = this.productInfo;
    const { cardCode, phone } = Stores.AppMod.userInfo || {};
    const isWeChat = Util.isWeiXin();

    if (isWeChat) {
      initConfig(); // 初始化微信配置
      const userInfo = Util.getLocalCache(Config.localStorageKeys.member_userInfo) || {};
      let userId = '';
      let cardCode = '';
      if (userInfo) {
        userId = userInfo.id;
        cardCode = userInfo.cardCode;
      }
      if (userId) {
        let { href } = window.location;
        let isLY = sessionStorage.getItem('systemCode') == 'LY' || Stores.AppMod.isLY;
        let p = phone;
        if (!Stores.BusinessCard.info.id) {
          yield Stores.BusinessCard.getCardInfo();
        }
        if (Stores.BusinessCard.info.phone && Stores.BusinessCard.info.phone.indexOf('*') != -1) {
          let newInfo = { ...Stores.BusinessCard.info };
          if (!Stores.BusinessCard.decyptInfo.phone) {
            let decyptPhone = yield Stores.AppMod.getDecyptMsg({
              scene: 224,
              id: Stores.BusinessCard.info.id,
              channal: ''
            });
            Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
              decyptInfo: { ...Stores.BusinessCard.decyptInfo, phone: decyptPhone }
            });
            yield Stores.BusinessCard.changeState({
              decyptInfo: { ...Stores.BusinessCard.decyptInfo, phone: decyptPhone },
              isSecret: false
            });
            newInfo.phone = decyptPhone;
          } else {
            newInfo.phone = Stores.BusinessCard.decyptInfo.phone;
          }
          if (!Stores.BusinessCard.decyptInfo.name) {
            let decyptName = yield Stores.AppMod.getDecyptMsg({
              scene: 125,
              id: Stores.BusinessCard.info.id,
              channal: ''
            });
            Util.setLocalCache(Config.localStorageKeys.bussiness_card, {
              decyptInfo: { ...Stores.BusinessCard.decyptInfo, name: decyptName }
            });
            yield Stores.BusinessCard.changeState({
              decyptInfo: { ...Stores.BusinessCard.decyptInfo, name: decyptName }
            });
            newInfo.name = decyptName;
          } else {
            newInfo.name = Stores.BusinessCard.decyptInfo.name;
          }

          yield Stores.BusinessCard.changeState({
            info: newInfo
          });
        }
        // 假如是二次分享的话，这种拼接是会有问题的，相当于拼接了两个以上share_user_id
        if (href.includes('share_user_id') || href.includes('cardCode')) {
          let arr = href.split('&');
          arr.forEach((item, i) => {
            if (item.includes('share_user_id') || item.includes('cardCode')) {
              arr[i] = '';
            }
          });
          //   arr.forEach((item2, k) => {
          //     if (item2) {
          //       href += (k !== 0 ? '&' : '') + item2;
          //     }
          //   });
          this.shareLink = `${arr.join('&')}&share_user_id=${userId}&cardCode=${cardCode}${
            isLY
              ? '&systemCode=LY'
              : '&name=' +
                encodeURIComponent(Stores.BusinessCard.info.name) +
                '&phone=' +
                (p || Stores.BusinessCard.info.phone)
          }&subActivityId=${
            sessionStorage.getItem('subActivityId') || ''
          }&subActivityChannel=${sessionStorage.getItem('subActivityChannel')}`;
        } else {
          let res = href.indexOf('?') != -1 ? href + '&' : href + '?';
          this.shareLink = `${res}share_user_id=${userId}&cardCode=${cardCode}${
            isLY
              ? '&systemCode=LY'
              : '&name=' +
                encodeURIComponent(Stores.BusinessCard.info.name) +
                '&phone=' +
                Stores.BusinessCard.info.phone
          }&subActivityId=${
            sessionStorage.getItem('subActivityId') || ''
          }&subActivityChannel=${sessionStorage.getItem('subActivityChannel')}`;
        }

        if (this.shareId) {
          this.shareLink = Util.replaceQueryParam(this.shareLink, 'shareId', this.shareId);
        }
        if (cardCode) {
          this.shareLink = Util.replaceQueryParam(this.shareLink, 'cardCode', cardCode);
          if (this.shareLink.includes('bindCardCode')) {
            this.shareLink = Util.replaceQueryParam(this.shareLink, 'bindCardCode', cardCode);
          }
        }
        if (this.invitationUserId) {
          this.shareLink = Util.replaceQueryParam(this.shareLink, 'invitationUserId', userId);
        }
      }
      if (this.shareLink) {
        if (Stores.AppMod.isTeamShareFlag) {
          let res = this.shareLink.indexOf('?') != -1 ? this.shareLink + '&' : this.shareLink + '?';
          let fromTeamShareFlag = await Stores.AppMod.getAutoSortResult();
          if (fromTeamShareFlag) {
            this.shareLink = res + `fromTeamShareFlag=${fromTeamShareFlag}`;
          }
        }
      }

      const title = name;
      const desc =
        shareSubTitle ||
        (this.productInfo || {}).shareSubTitle ||
        `我在有享云商发现一个不错的产品，赶快来看看吧`;

      const defaultObj = {
        title,
        link: this.shareLink,
        imgUrl: Util.getProductImgUrl(mediaRespDtoList),
        suc: () => {
          // this.commodityShare({ ...this.shareParams });
          // 神策数据发送
          window.sensors.track('commodityShare', {
            commodity_id: id,
            commodity_name: name,
            channal: '微信',
            location_url: '/shop/productDetail/:id'
          });
          if (this.newSource === 'MRYP') {
            window.sensors.track('dailyOne', {
              type: 2, // type 1,2,3,4  访问、分享、时长、下单
              channal: 'H5',
              isLogin: !!Stores.AppMod.token,
              userId: userId || '',
              cardCode: cardCode || '',
              productId: this.productId
            });
          }
        },
        cancel: () => {
          // this.commodityShare({ ...this.shareParams, isShare: 1 });
        }
      };
      // 分享给朋友
      shareFriend({
        ...defaultObj,
        desc
      });

      // 分享到朋友圈
      sharePyq(defaultObj);
    } else {
      this.getShareLinkUrl();
    }
  });

  /**
   * 秒杀 gift列表
   */

  // getActivityGiftListSeckill = flow(function* (params){
  //  // 秒杀
  //  try {

  //   const res = yield Serv.getActivityIdsGiftListForSeckill({
  //     secKillId: this.activityId,
  //     fullGiftIds: this.giftActId,
  //     count:this.itemNum,
  //     bv: this.activityInfo.discountBv,
  //     price: this.activityInfo.discountSalePrice,
  //   });
  //   const {giftItemList} = res.data ? res.data[0] :{}
  //   this.giftListSeckill = giftItemList
  // } catch (error) {
  //   this.giftListSeckill = []

  // }
  // })

  /**
   * 获取满赠列表
   */
  getActivityGiftList = flow(function* (id, flagToast = false) {
    if (!id) {
      return;
    }
    let that = this;
    const MapServer = new Proxy(
      {
        9: {
          method: Serv.getActivityIdsGiftListForSeckill,
          params: {
            secKillId: this.activityId,
            fullGiftIds: this.giftActId,
            count: this.itemNum,
            bv: this.activityInfo ? this.activityInfo.discountBv : void 0,
            price: this.activityInfo ? this.activityInfo.discountSalePrice : void 0
          }
        }
      },
      {
        get(target, props) {
          if (!(props in target)) {
            let resArr = [];
            if (Array.isArray(toJS(that.activityList))) {
              let arr = that.activityList.map((m) => m.activityBaseInfoList);
              arr.forEach((f) => {
                f.forEach((fi) => {
                  if (fi.selected) {
                    resArr.push(fi);
                  }
                });
              });
            }
            let productInfo = toJS(that.productInfo) || {};
            if (productInfo && productInfo.detail) {
              // 商品详情删除detail属性
              delete productInfo.detail;
            }
            return {
              method: Serv.getJTActivityIdsGiftList,
              params: {
                activityIds: id.split(','),
                distributionRatio: that.orderProperty,
                orderType: that.orderType,
                activityInfoReqDtoList: resArr,
                itemfoReqDtoList: [
                  {
                    ...productInfo,
                    itemNum: that.itemNum,
                    itemSerial: that.productInfo.id,
                    skuSerial: that.productInfo.skuId
                  }
                ]
              }
            };
          }
          return target[props];
        }
      }
    );

    // this.giftList = []; // 切换置空
    try {
      const targetMethod = MapServer[this.activityType];

      const { data, resultCode } = yield targetMethod['method'](targetMethod['params']);
      if (this.activityType == '9') {
        const res = Array.isArray(data) && data.map((v) => v.activityId);
        const acList = toJS(this.activityList).filter((v) => v.activityType == 3);
        // console.log(toJS(this.activityList));
        if (this.flashSaleFullToGiveSuperpositionTag) {
          this.activityList = acList.map((v) => {
            return {
              ...v,
              activityBaseInfoList:
                Array.isArray(v.activityBaseInfoList) &&
                v.activityBaseInfoList.map((u) => {
                  console.log(u, res, res.includes(u.activityId), '---flag-->');
                  if (res.includes(u.activityId)) {
                    return u;
                  } else {
                    // flagToast &&  u.activityTitle!='不使用' && Toast.fail('xx',1.5)
                    return {
                      ...u
                      //  selected: false
                    };
                  }
                })
            };
          });
        } else {
          this.activityList = [];
        }
      }
      const oldGiftList = cloneDeep(toJS(this.giftList)) || [];
      let AllGiftList = [];
      let AllGiftListActivity = [];
      let modalObject = {};
      if (`${resultCode}` == '0') {
        // 对比新旧赠品+券的集合，有变化才清空（阶梯切换）
        const oldKeys = oldGiftList
          .flat()
          .map((g) => g.itemSerial || g.id)
          .filter(Boolean)
          .sort()
          .join(',');
        const newKeys = data
          .flatMap((d) => [
            ...(d.giftItemList || []).map((g) => g.itemSerial),
            ...(d.couponList || []).map((c) => c.id)
          ])
          .filter(Boolean)
          .sort()
          .join(',');
        if (oldKeys !== newKeys) {
          this.selectedGiftItemsArray = {};
        }
        data.forEach((datas, index) => {
          let giftType = get(datas, 'giftType');
          let presentCount = get(datas, 'presentCount');
          let activityId = get(datas, 'activityId');
          let presentWay = get(datas, 'presentWay');
          let newgiftItemList = [];
          if (get(datas, 'giftItemList', []) && get(datas, 'giftItemList', []).length > 0) {
            const hisGift =
              !!oldGiftList.length &&
              oldGiftList.find((el) => el[0] && el[0].activityId == activityId);
            let _selectedGiftItemsArray = toJS(this.selectedGiftItemsArray);
            newgiftItemList = get(datas, 'giftItemList', []).map((item) => {
              item.activityId = activityId;
              if (hisGift && !!item.subGiftItemSelectRespDtoList) {
                hisGift.forEach((el) => {
                  if (el.itemSerial == item.itemSerial) {
                    item.subGiftItemSelectRespDtoList = el.subGiftItemSelectRespDtoList;
                  }
                });
              } else if (hisGift && !item.subGiftItemSelectRespDtoList) {
                hisGift.forEach((el) => {
                  if (el.itemSerial == item.itemSerial && el.itemSelectNum > 0) {
                    item.itemSelectNum = el.itemSelectNum;
                  }
                });
              }
              const id = item.itemSerial || item.id;
              let sign =
                (_selectedGiftItemsArray &&
                  _selectedGiftItemsArray[activityId] &&
                  _selectedGiftItemsArray[activityId][id]) ||
                false;
              if (sign && item.subGiftItemSelectRespDtoList) {
                if (
                  !(
                    item.subGiftItemSelectRespDtoList &&
                    item.subGiftItemSelectRespDtoList.some((el) => el.isSelected)
                  )
                ) {
                  _selectedGiftItemsArray[activityId][id] = false; // 取消选中
                }
              } else if (sign && !item.subGiftItemSelectRespDtoList) {
                item.itemSelectNum = 1;
              }
              return item;
            });
            this.selectedGiftItemsArray = { ..._selectedGiftItemsArray };
            if (
              +giftType !== 5 &&
              newgiftItemList.length == 1 &&
              !newgiftItemList[0].subGiftItemSelectRespDtoList
            ) {
              //默认选中赠品
              // console.log('-->执行了', toJS(newgiftItemList[0]));
              let obj = this.selectedGiftItemsArray;
              let obj1 = newgiftItemList[0] || {};
              let keyP = obj1['itemSerial'] || obj1[0]['id'];
              obj[activityId] = obj[activityId] || {};
              obj[activityId][keyP] = true;
              this.selectedGiftItemsArray = { ...obj };
            }
          }
          let newCouponList = [];
          if (get(datas, 'couponList', []) && get(datas, 'couponList', []).length > 0) {
            newCouponList = get(datas, 'couponList', []).map((item) => {
              item.activityId = activityId;
              item.couponName = item.couponName || item.giftCouponName;
              item.couponType =
                item.couponType !== undefined ? item.couponType : item.deductionType;
              item.couponValue = item.couponValue !== undefined ? item.couponValue : item.giftValue;
              return item;
            });
          }
          let newRightsList = [];
          if (get(datas, 'rightsList', []) && get(datas, 'rightsList', []).length > 0) {
            newRightsList = get(datas, 'rightsList', []).map((item) => {
              item.activityId = activityId;
              item.giftMulti = datas.giftMulti;
              return item;
            });
          }
          let theGiftList;
          if (+giftType === 5) {
            theGiftList = [...newgiftItemList, ...newCouponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
              item.giftType = 5;
            });
          } else {
            theGiftList = [newgiftItemList, newCouponList, newRightsList][datas.giftType - 1] || [];
            theGiftList.forEach((item) => {
              item.giftType = item.giftType || +giftType;
            });
          }
          const newTheGiftList = theGiftList.map((itemVal) => {
            itemVal.presentWay = presentWay;
            itemVal.presentCount = presentCount;
            itemVal.giftMulti = datas.giftMulti;
            return itemVal;
          });
          AllGiftList[index] = newTheGiftList;
          AllGiftListActivity[index] = activityId;
          let thisModalObject = {
            giftType,
            presentCount,
            presentWay
          };
          modalObject[index] = thisModalObject;

          if (Object.keys(this.selectedGiftItemsArray[activityId] || {}).length > 0) {
            return true;
          }
          if (presentWay == 1) {
            theGiftList.forEach((item) => {
              // this.changeSelectedGift(
              //   giftType == 1 ? item.itemSerial : item.id,
              //   false,
              // );
              // this.changeSelectedGift(
              //   giftType == 1 ? item.itemSerial : item.id,
              //   false,
              // );
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
              const hasInventory = effectiveType === 2 || item.availableStock > 0;
              if (!item.subGiftItemSelectRespDtoList && hasInventory) {
                const returnValue = this.changeSelectedGiftNew(
                  effectiveType === 1 ? item.itemSerial : item.id,
                  false,
                  activityId,
                  item.giftCount,
                  '',
                  presentWay,
                  theGiftList.length
                );
              }
            });
          } else if (presentWay == 2) {
            let count = presentCount;
            theGiftList.forEach((item) => {
              if (count > 0) {
                // this.changeSelectedGift(
                //   giftType == 1 ? item.itemSerial : item.id,
                //   false,
                // );
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +giftType;
                const hasInventory = effectiveType === 2 || item.availableStock > 0;
                if (!item.subGiftItemSelectRespDtoList && hasInventory) {
                  const returnValue = this.changeSelectedGiftNew(
                    effectiveType === 1 ? item.itemSerial : item.id,
                    false,
                    activityId,
                    item.giftCount,
                    '',
                    presentWay,
                    presentCount
                  );
                }
                count--;
              }
            });
          } else if (presentWay == 3) {
            // 经产品更改需求  presentWay==3默认不选
            // let count = presentCount;
            // theGiftList.forEach(item => {
            //   if (count > 0) {
            //     if (!item.subGiftItemSelectRespDtoList) {
            //     const returnValue = this.changeSelectedGiftNew(
            //       giftType == 1 ? item.itemSerial : item.id,
            //       false,
            //       activityId,
            //       item.giftCount,
            //       '',
            //       presentWay,
            //       presentCount,
            //     );
            //     item.itemSelectNum = 1
            //     }
            //     count--;
            //   }
            // });
          }
        });
        this.modalObject = modalObject;
        this.giftList = AllGiftList;
        this.giftListActivity = AllGiftListActivity;
      }
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 获取加价购列表
   */
  getActivityIncPriceList = flow(function* (id) {
    try {
      // this.resetIncPrice();
      const params = {
        calculateDiscountReqDtoList: [
          {
            activityInfoReqDtoList: [
              {
                activityId: id,
                activityType: 4
              }
            ],
            itemfoReqDtoList: [
              {
                bv: this.productInfo.bv,
                itemNum: this.itemNum,
                itemSerial: this.productInfo.id,
                skuSerial: this.productInfo.skuId,
                price: this.productInfo.price
              }
            ],
            distributionRatio: this.distributionRatio,
            orderType: this.orderType
          }
        ],
        distributionRatio: this.orderProperty,
        orderType: this.orderType
      };
      if (this.discount) {
        params.discount = this.discount;
      }
      const { data } = yield Serv.getActivityIncPriceList(params);
      // 修复加价购商品存在 => 不存在时，加购商品列表没有隐藏
      // if (data.increment <= 0) return;
      //每次请求之前先把选中的加价购商品清空，两个加价购活动对应的加价购商品一样的时候，切换活动会默认选中
      this.incPriceList.forEach((item) => {
        const id = item.itemId;
        if (this.selectedGiftItems[id]) {
          delete this.selectedGiftItems[id];
        }
      });

      this.incPriceList = data.itemRespDtoList.map((item) => ({ ...item, itemNum: 1 })) || [];
      this.maxIncPriceNum = data.increment;
      this.incPriceMoney = data.priceIncrease;
      this.incPriceType = data.priceIncreaseType;
      this.incRand = data.random;
      this.blessingBagImg = data.blessingBagImg;
      this.blessingBagAlias = data.blessingBagAlias;

      //只有一个加价购商品时，默认选中
      if (this.incPriceList.length === 1) {
        const additionItem = this.incPriceList[0] || {};

        const defaultChooseFlag =
          additionItem.itemNum + this.incPriceTotalCount <= this.maxIncPriceNum;
        const hasSku = !!additionItem.subGiftItemSelectRespDtoList;
        if (defaultChooseFlag && !hasSku) {
          this.changeSelectedGift(additionItem.itemId, false);
        }
      }
    } catch (error) {}
  });

  // 店长最大折扣
  // @computed
  // get maxMasterDR() {
  //   let arr = []
  //   this.selectedList.map(item => {
  //     if (item['allocateCargoScale']) {
  //       arr = [...arr, item['allocateCargoScale'].split(",")]
  //     }
  //   })
  //   return Math.max(...arr)
  // }

  /**
   * 查询当前商品可参与的促销活动列表信息（根据订单类型、配送比例）
   */
  getActivityList = flow(function* (showLoading = false, callback, isInit = false) {
    /*
      activityUsage (显示选择不使用逻辑) 0：都不显示，1：促销活动显示，资格购不显示，2：促销活动不显示，资格购显示，3：都显示
    */
    const { activityUsage } = Stores.AppMod.userInfo;
    console.log(Stores.AppMod.token);
    console.log(this.orderType);
    console.log(this.orderProperty);
    console.log(this.discount);
    console.log([10].includes(+this.activityType));
    console.log(this.activityId);
    if (
      !Stores.AppMod.token ||
      !this.orderType ||
      (!this.orderProperty && !this.discount) ||
      (![10, 9, 12].includes(+this.activityType) && this.activityId)
    ) {
      this.getActiveList = [''];
      return;
    }

    let params = {
      orderType: this.orderType,
      distributionRatio: this.orderProperty,
      itemSerial: this.productInfo.id || this.productId || '',
      discount: this.discount,
      qualificationId: this.activityId
    };
    if (this.showFlag) {
      params.shareActivityId = this.activityId;
    }

    this.giftActId = '';
    this.incPriceId = '';
    if (
      sessionStorage.getItem('subActivityId') &&
      sessionStorage.getItem('subActivityId') != null &&
      sessionStorage.getItem('subActivityId') != 'null'
    ) {
      params.subActivityId = sessionStorage.getItem('subActivityId');
    }
    try {
      showLoading && Toast.loading('请稍候', 100);
      const { data } = yield Serv.getActivityList({
        ...params,
        source: this.source
      });
      showLoading && Toast.hide();
      if (data) {
        let { positiveList, negativeList } = data;

        positiveList &&
          positiveList.forEach((item) => {
            if (
              item.activityType === 4 &&
              item.activityBaseInfoList &&
              item.activityBaseInfoList.length > 0
            ) {
              const notCancelList = item.activityBaseInfoList.filter(
                (act) => act.notCancelTag === 1
              );
              // 当后管配置有加价购不可取消时 则筛选出不可取消的这个活动的第一项 作为唯一加价购
              if (notCancelList.length > 0) {
                item.activityBaseInfoList = [notCancelList[0]];
              }
            }
          });

        console.log('positiveList', positiveList);
        let activityList = positiveList || [];
        let arr1 = Array.isArray(positiveList) ? positiveList : [];
        let arr2 = Array.isArray(negativeList) ? negativeList : [];
        this.getActiveListForTag = [...arr1, ...arr2];
        this.getActiveList = activityList;
        // 非资格购入口进来，需要过滤掉资格购
        if (this.activityType != 10) {
          activityList = activityList.filter((item) => item.activityType != 6);
        }
        //秒杀  过滤其他，留下满赠
        if (this.activityType == 9) {
          // console.log(activityList);
          activityList = activityList.filter((item) => item.activityType == 3);
        }
        // activityList.findIndex(res => id == activityListidz)
        // 当前是否有此活动
        let hasAct =
          activityList.findIndex(({ activityBaseInfoList }) => {
            return (
              activityBaseInfoList.findIndex(({ activityId: actId }) => actId === this.selActId) !==
              -1
            );
          }) !== -1;
        for (let i = 0; i < activityList.length; i++) {
          let { activityBaseInfoList, activityType } = activityList[i];
          // if (+activityType === 3) {
          //   // 如果是满赠活动 过滤出默认赠送的活动
          //   let tempList = [];
          //   let defaultActivityList = [];
          //   activityBaseInfoList.forEach(item => {
          //     +item.defaultGivePresent !== 1 ? tempList.push(item) : defaultActivityList.push(item);
          //   });
          //   activityBaseInfoList = tempList;
          //   this.defaultActivityList = defaultActivityList;
          // }
          if (activityBaseInfoList && activityBaseInfoList.length > 0) {
            // 赠品活动 3 或加价购活动
            let selectIndex = 0;
            // if (!this.giftActId && !this.incPriceId) {
            // 折扣模式 已废弃
            if (this.discount) {
              for (let i = 0; i < activityBaseInfoList.length; i++) {
                if (activityBaseInfoList[i].allowDiscount) {
                  selectIndex = i;
                  activityBaseInfoList[i].selected = true;
                  break;
                }
              }
            } else {
              // 来自自定义专题页  默认选中当前活动类型项 其他活动不使用
              if (hasAct) {
                activityBaseInfoList.map((val, index) => {
                  if (val.activityId === this.selActId) {
                    selectIndex = index;
                    activityBaseInfoList[selectIndex].selected = true;
                  }
                });
              } else {
                activityBaseInfoList[0].selected = true;
              }
            }
            if (activityType === 3 || activityType === 4) {
              let group = activityList.find((o) => o.activityType === (activityType === 3 ? 4 : 3));
              if (group && group.activityBaseInfoList) {
                let inc = group.activityBaseInfoList.find((g) => g.selected);
                if (inc && (!inc.shared || !activityBaseInfoList[selectIndex].shared))
                  activityBaseInfoList[selectIndex].selected = false;
              }
            }
            activityType == 3 && !this.giftActId
              ? (this.giftActId = activityBaseInfoList[selectIndex].selected
                  ? activityBaseInfoList[selectIndex].activityId
                  : '')
              : activityType == 4 && !this.incPriceId
                ? (this.incPriceId = activityBaseInfoList[selectIndex].selected
                    ? activityBaseInfoList[selectIndex].activityId
                    : '')
                : '';
            // }
            if (+activityType === 6) {
              activityBaseInfoList[0].selected = true;
            }
            // 加价购选中不使用模式
            // if (
            //   !(
            //     Stores.AppMod.isLY ||
            //     sessionStorage.getItem('systemCode') == 'LY' ||
            //     Stores.AppMod.isWDY ||
            //     Stores.AppMod.isKER
            //   )
            // ) {
            // activityBaseInfoList.push({
            //   activityTitle: '不使用',
            //   activityType,
            //   selected: !activityBaseInfoList[selectIndex].selected,
            //   allowDiscount: true,
            // });
            // }
            // notCancelTag--后管配置的不使用
            const notCancelTag = activityList[i].activityBaseInfoList[0].notCancelTag == 1;

            switch (activityUsage) {
              case 1:
                activityType != payActivityTypeMap.QUALIFICATION &&
                  activityBaseInfoList.push({
                    activityTitle: '不使用',
                    activityType,
                    selected: !activityBaseInfoList[selectIndex].selected,
                    allowDiscount: true
                  });
                break;
              case 2:
                if (notCancelTag) break;
                activityType == payActivityTypeMap.QUALIFICATION &&
                  !this.qualificationUnCancel &&
                  activityBaseInfoList.push({
                    activityTitle: '不使用',
                    activityType,
                    selected: !activityBaseInfoList[selectIndex].selected,
                    allowDiscount: true
                  });
                break;
              case 3:
                if (notCancelTag) break;
                if (
                  (activityType == payActivityTypeMap.QUALIFICATION &&
                    !this.qualificationUnCancel) ||
                  activityType !== payActivityTypeMap.QUALIFICATION
                ) {
                  activityBaseInfoList.push({
                    activityTitle: '不使用',
                    activityType,
                    selected: !activityBaseInfoList[selectIndex].selected,
                    allowDiscount: true
                  });
                }
                break;
              default:
                break;
            }
          }
        }
        console.log('activityList222', activityList);
        // const newActivityList = activityList.map(item => {
        //   if (+item.activityType === 3) {
        //     const itemActivityBaseInfoList = item.activityBaseInfoList.filter(item => {
        //       return +item.defaultGivePresent !== 1;
        //     });
        //     item.activityBaseInfoList = itemActivityBaseInfoList;
        //   }
        //   return item;
        // });
        this.activityList = activityList;
        this.giftList = [];
        this.selectedGiftList = [];
        this.selectedGiftItems = {};
        this.selectedGiftItemsArray = {};
        this.incPriceList = [];

        this.disabledActivityList = negativeList || [];
        setTimeout(() => {
          if (this.giftActId) {
            this.getActivityGiftList(this.giftActId);
          }
          if (this.incPriceId) {
            this.getActivityIncPriceList(this.incPriceId);
          }
          this.getNowPriceAndBvInfo(isInit);
        }, 0);
        setTimeout(() => {
          // 如果资格购有勾选 则走一遍点击勾选资格购的逻辑
          const selectZggData = activityList.find((item) => +item.activityType === 6);
          const selectZggIndex = activityList.findIndex((item) => +item.activityType === 6);
          const zggBaseInfoList = (selectZggData && selectZggData.activityBaseInfoList) || [];
          const zggItem = !!zggBaseInfoList.length && zggBaseInfoList.find((item) => item.selected);
          const zggItemIndex =
            !!zggBaseInfoList.length && zggBaseInfoList.findIndex((item) => item.selected);
          if (selectZggIndex && zggItem) {
            this.changeActivitySelected(selectZggIndex, zggItemIndex);
          }
        }, 500);
        callback && callback();
        return data;
      } else {
        this.activityList = [];
        this.getActiveList = [''];
      }
    } catch (error) {
      this.getActiveList = [''];
    }
  });

  // 正向选择
  @action
  handleSelectedGiftList() {
    // 处理选择的
    let AllSelectedGiftList = [];
    let selectedGiftItems = toJS(this.selectedGiftItems);
    let keysArray = Object.values(this.selectedGiftItemsArray); // 只存储赠品信息
    let keys = keysArray.map((itemValue) => {
      return Object.keys(itemValue);
    });
    keys = keys.flat();
    console.log(toJS(this.giftList));
    toJS(this.giftList).forEach((items, index) => {
      let selectedGiftList = [];
      const { activityId } = items[0] || {};
      let selectValue = this.selectedGiftItemsArray[activityId] || {};
      items.forEach((item) => {
        const effectiveType =
          item.resolvedGiftType !== undefined ? item.resolvedGiftType : item.giftType;
        let id = effectiveType == 1 ? item.itemSerial : item.id;
        selectValue[id] == true && selectedGiftList.push(item);
      });
      AllSelectedGiftList[index] = selectedGiftList;
    });
    this.selectedGiftList = AllSelectedGiftList;
  }

  // 选择赠品
  @action
  changeSelectedGift(id, isSelected) {
    let selectedGiftItems = { ...this.selectedGiftItems };
    selectedGiftItems[id] = !isSelected;
    this.selectedGiftItems = selectedGiftItems;
  }

  @action
  changeSelectedGiftNew(
    id,
    isSelected,
    activityId,
    giftCount,
    count,
    presentWay,
    presentCount,
    sign,
    isSku
  ) {
    console.log(id, isSelected, activityId, giftCount);
    let selectedGiftItemsArray = cloneDeep(this.selectedGiftItemsArray);
    console.log(selectedGiftItemsArray);
    selectedGiftItemsArray[activityId] = selectedGiftItemsArray[activityId] || {};
    if (count == 1 && presentWay != 3) {
      for (var k in selectedGiftItemsArray[activityId]) {
        if (k == id) {
          selectedGiftItemsArray[activityId][k] = !isSelected;
        } else if (k != 'giftCount') {
          selectedGiftItemsArray[activityId][k] = false;
        }
      }
    }
    selectedGiftItemsArray[activityId][id] = !isSelected;
    giftCount && !!giftCount.chose
      ? null
      : (selectedGiftItemsArray[activityId].giftCount = giftCount);
    let selectNum = 0;
    let newItem = JSON.parse(JSON.stringify(selectedGiftItemsArray[activityId]));
    delete newItem.giftCount;
    Object.values(newItem).forEach((item) => {
      if (item) {
        selectNum++;
      }
    });
    let returnValue = selectNum > 0;

    // 赠品全选逻辑
    // if (sign && presentWay == 1 && isSelected) {
    //   return false;
    // }
    // 赠品全选逻辑
    if (sign && presentWay == 1 && !isSku) {
      return false;
    }
    if (giftCount && !!giftCount.chose && presentWay != 3) {
      if (returnValue) {
        this.selectedGiftItemsArray = selectedGiftItemsArray;
      } else {
        Toast.info('赠品至少选择一个哦');
        return false;
      }
    }
    this.selectedGiftItemsArray = selectedGiftItemsArray;
    return true;
  }

  @action
  getCurrentSelected(activityId) {
    let list = [...this.activityList];
    list.map((item, findex) => {
      item.activityBaseInfoList.map((subItem, sindex) => {
        if (subItem.activityId == activityId) {
          this.changeActivitySelected(findex, sindex, true);
        }
      });
    });
  }

  /**
   * 活动下单，通用提示处理
   */
  handleActivityCommonTip(title = '提示', resultMsg, callback) {
    alert(title, resultMsg, [
      {
        text: '确认',
        onPress: () => {}
      }
    ]);
  }

  // 如果选择的是满赠 判断是满赠多选还是满赠单选
  @action
  checkCanBothSelect = (activityItem, index) => {
    const { fullToGiveSuperpositionTag } = activityItem[index];
    if (+fullToGiveSuperpositionTag !== 1) {
      for (const item of activityItem) {
        item.selected = false;
      }
      activityItem[index].selected = true;
      if (index === activityItem.length - 1) {
        this.giftList = []; // 满赠活动置为空
      }
    } else {
      if (activityItem[index].selected == true) {
        return;
      }
      for (const item of activityItem) {
        if (+item.fullToGiveSuperpositionTag === 0) {
          item.selected = false;
        }
      }

      activityItem[activityItem.length - 1].selected = false; // 最后一项置为未选择
      activityItem[index].selected = !activityItem[index].selected; // 多选置为相反
    }
    return activityItem;
  };

  // 判断满赠是否与加价购同享
  @action
  checkGroupCanBothSelect_ManZeng = (list, activity) => {
    let hasChange = false;
    if (activity && activity.selected) {
      // 选择了某个满赠活动
      const incGroupIndex = list.findIndex((o) => o.activityType === 4);
      if (incGroupIndex >= 0) {
        // 存在加价购活动组
        const incActivity = (list[incGroupIndex].activityBaseInfoList || []).find(
          (o) => o.selected
        );
        if (incActivity && incActivity.activityId) {
          // 当前选中了某一个加价购活动
          if (!activity.shared || !incActivity.shared) {
            // 情况1: 此满赠活动不与加价购同享 则干掉加价购
            // 情况2: 此满赠活动与加价购同享 但有可能 当前选中的加价购活动不与满赠同享 则干掉加价购
            list[incGroupIndex].activityBaseInfoList.forEach((o) => {
              o.selected = false;
            });
            const nouse = list[incGroupIndex].activityBaseInfoList.find(
              (o) => o.activityTitle == '不使用'
            );
            if (nouse) nouse.selected = true;
            hasChange = true;
          }
        }
      }
      // 处理资格购活动选择
      hasChange = this.checkZggSelected(list, hasChange);
    }
    return hasChange;
  };

  // 判断加价购是否与满赠同享
  @action
  checkGroupCanBothSelect_JiaJiaGou = (list, activity) => {
    let hasChange = false;
    if (activity && activity.selected) {
      // 选择了某个加价购活动
      const manzengGroupIndex = list.findIndex((o) => o.activityType === 3);
      if (manzengGroupIndex >= 0) {
        // 存在满赠活动组 遍历该活动组
        (list[manzengGroupIndex].activityBaseInfoList || []).forEach((manzeng) => {
          if (manzeng.activityId && manzeng.selected) {
            // 当前选中了此满赠活动
            if (!activity.shared || !manzeng.shared) {
              // 情况1: 加价购活动不与满赠同享 则干掉满赠
              // 情况2: 加价购活动与满赠同享 但有可能 此满赠活动不与加价购同享 则干掉此满赠
              manzeng.selected = false;
              hasChange = true;
            }
          }
        });
        // 一顿操作后 寻找当前是否还有选中的满赠活动
        const manzengSelected = (list[manzengGroupIndex].activityBaseInfoList || []).find(
          (o) => o.selected
        );
        if (!manzengSelected || !manzengSelected.activityId) {
          // 什么都没选中 则选中不使用
          const nouse = list[manzengGroupIndex].activityBaseInfoList.find(
            (o) => o.activityTitle == '不使用'
          );
          if (nouse) {
            nouse.selected = true;
            hasChange = true;
          }
        }
      }
      // 处理资格购活动选择
      hasChange = this.checkZggSelected(list, hasChange);
    }
    return hasChange;
  };

  // 判断资格购是否与促销活动同享
  @action
  checkGroupCanBothSelect_ZiGeGou = (list, activity) => {
    let hasChange = false;
    if (activity && activity.selected) {
      // 选择了某个加价购活动
      const manzengGroupIndex = list.findIndex((o) => o.activityType === 3);
      if (manzengGroupIndex >= 0) {
        // 存在满赠活动组 遍历该活动组
        (list[manzengGroupIndex].activityBaseInfoList || []).forEach((manzeng) => {
          if (manzeng.activityId && manzeng.selected) {
            // 当前选中的资格购活动 shareWithOtherActivity  1->与促销同享   0->与促销不同享
            if (!activity.shareWithOtherActivity) {
              // 如果资格购不同享 把满赠干掉
              manzeng.selected = false;
              hasChange = true;
            }
          }
        });
        // 一顿操作后 寻找当前是否还有选中的满赠活动
        const manzengSelected = (list[manzengGroupIndex].activityBaseInfoList || []).find(
          (o) => o.selected
        );
        if (!manzengSelected || !manzengSelected.activityId) {
          // 什么都没选中 则选中不使用
          const nouse = list[manzengGroupIndex].activityBaseInfoList.find(
            (o) => o.activityTitle == '不使用'
          );
          if (nouse) {
            nouse.selected = true;
            hasChange = true;
          }
        }
      }
      // 选择了某个满赠活动
      const incGroupIndex = list.findIndex((o) => o.activityType === 4);
      if (incGroupIndex >= 0) {
        // 存在加价购活动组
        const incActivity =
          (list[incGroupIndex].activityBaseInfoList || []).find((o) => o.selected) || {};
        if (incActivity.activityId) {
          // 当前选中的资格购活动 shareWithOtherActivity  1->与促销同享   0->与促销不同享
          if (!activity.shareWithOtherActivity) {
            // 如果资格购不同享 把加价购干掉
            list[incGroupIndex].activityBaseInfoList.forEach((o) => {
              o.selected = false;
            });
            const nouse = list[incGroupIndex].activityBaseInfoList.find(
              (o) => o.activityTitle == '不使用'
            );
            if (nouse) nouse.selected = true;
            hasChange = true;
          }
        }
      }
    }
    return hasChange;
  };

  @action
  checkZggSelected(list, hasChange) {
    let _hasChange = hasChange || false;
    const zggGroupIndex = list.findIndex((o) => o.activityType === 6);
    if (zggGroupIndex >= 0) {
      // 存在资格购活动组
      const zggActivity = (list[zggGroupIndex].activityBaseInfoList || {}).find((o) => o.selected);
      if (zggActivity && zggActivity.activityId) {
        // 当前选中的资格购活动 shareWithOtherActivity  1->与促销同享   0->与促销不同享
        if (!zggActivity.shareWithOtherActivity) {
          // 只要该资格购存在互斥 就干掉资格购
          list[zggGroupIndex].activityBaseInfoList.forEach((o) => {
            o.selected = false;
          });
          const nouse = list[zggGroupIndex].activityBaseInfoList.find(
            (o) => o.activityTitle == '不使用'
          );
          if (nouse) nouse.selected = true;
          _hasChange = true;
        }
      }
    }
    return _hasChange;
  }

  @action
  changeActivitySelected(activityIndex, index, ignoreMaster = false) {
    let list = [...this.activityList];
    let currentSelect = list[activityIndex].activityBaseInfoList[index];
    // 有活动id，折扣模式，活动不可参与，弹提示
    if (
      currentSelect.activityId &&
      this.isDiscountMode &&
      !currentSelect.allowDiscount &&
      currentSelect.vipUpgradeActivity != 1
    ) {
      Modal.alert('温馨提示', `您选择的活动与当前的折扣不匹配，是否确认使用该活动？`, [
        { text: '取消' },
        {
          text: '确定',
          onPress: () => {
            this.changeState({ discount: 1 });
            this.getActivityList(true, () => {
              this.getCurrentSelected(currentSelect.activityId);
            });
          }
        }
      ]);
      return;
    }
    let hasAffect = false;
    if (
      list[activityIndex].activityType == 3 &&
      list[activityIndex].activityBaseInfoList[index].activityId
    ) {
      this.checkCanBothSelect(list[activityIndex].activityBaseInfoList, index);
      hasAffect = this.checkGroupCanBothSelect_ManZeng(
        list,
        list[activityIndex].activityBaseInfoList[index]
      );
    } else {
      for (const item of list[activityIndex].activityBaseInfoList) {
        item.selected = false;
      }
      list[activityIndex].activityBaseInfoList[index].selected = true; // 设置某个活动为选中状态

      if (
        list[activityIndex].activityType == 4 &&
        list[activityIndex].activityBaseInfoList[index].activityId
      ) {
        // 加价购活动
        hasAffect = this.checkGroupCanBothSelect_JiaJiaGou(
          list,
          list[activityIndex].activityBaseInfoList[index]
        );
      }
      if (
        list[activityIndex].activityType == 6 &&
        list[activityIndex].activityBaseInfoList[index].activityId
      ) {
        // 资格购活动
        hasAffect = this.checkGroupCanBothSelect_ZiGeGou(
          list,
          list[activityIndex].activityBaseInfoList[index]
        );
      }
    }
    // 选择满赠的逻辑处理
    if (
      list[activityIndex].activityType == 3 &&
      list[activityIndex].activityBaseInfoList[index].activityId
    ) {
      let selectActivityIdList = [];
      for (const activityItem of toJS(list[activityIndex].activityBaseInfoList)) {
        activityItem.selected === true && selectActivityIdList.push(activityItem.activityId);
      }
      // this.giftActId = list[activityIndex].activityBaseInfoList[index].activityId;
      this.giftActId = selectActivityIdList.join(',');
      // this.getActivityGiftList(this.giftActId, true); // 获取满赠列表

      // this.getNowPriceAndBvInfo(); // 获取价格和BV信息

      if (hasAffect) {
        // 满赠影响了加价购
        this.incPriceId = '';
        this.incPriceList = [];
      }
    } else {
      this.getNowPriceAndBvInfo(); // 获取价格和BV信息
    }
    // 选择加价购的逻辑处理
    if (
      list[activityIndex].activityType == 4 &&
      list[activityIndex].activityBaseInfoList[index].activityId
    ) {
      this.incPriceId = list[activityIndex].activityBaseInfoList[index].activityId;
      this.getActivityIncPriceList(this.incPriceId); // 获取加价购列表

      if (hasAffect) {
        // 加价购影响了满赠
        const manzengGroup = list.find((o) => o.activityType === 3);
        let selectActivityIdList = [];
        for (const activityItem of manzengGroup.activityBaseInfoList) {
          if (activityItem.activityId && activityItem.selected)
            selectActivityIdList.push(activityItem.activityId);
        }
        if (selectActivityIdList.length > 0) {
          this.giftActId = selectActivityIdList.join(',');
          this.getActivityGiftList(this.giftActId, true);
        } else {
          this.giftActId = '';
          this.giftList = [];
          this.selectedGiftItemsArray = {};
        }
      }
    }
    // 选择资格购的逻辑处理
    if (
      list[activityIndex].activityType == 6 &&
      list[activityIndex].activityBaseInfoList[index].activityId
    ) {
      if (hasAffect) {
        // 资格购影响了满赠
        this.giftActId = '';
        this.giftList = [];
        this.selectedGiftItemsArray = {};
        // 资格购影响了加价购
        this.incPriceId = '';
        this.incPriceList = [];
      }
    }
    // 不使用之后 赠品信息置为空
    if (
      list[activityIndex].activityType == 3 &&
      list[activityIndex].activityBaseInfoList[index].activityTitle == '不使用'
    ) {
      this.giftActId = '';
      this.giftList = [];
      this.selectedGiftItemsArray = {};
    }
    // 不使用之后 加价购信息置为空
    if (
      list[activityIndex].activityType == 4 &&
      list[activityIndex].activityBaseInfoList[index].activityTitle == '不使用'
    ) {
      this.incPriceId = '';
      this.incPriceList = [];
    }
    this.getActivityGiftList(this.giftActId, true);
    this.activityList = toJS(list);
  }

  // 获取价格和BV信息
  @action
  getNowPriceAndBvInfo = (isInit = false) => {
    let giftItems = []; // 存放所有已选的实物赠品
    let couponRightsList = []; // 存放所有已选的赠券和赠权益
    const { id, price, skuId, allowDiscount } = this.productInfo;
    const {
      activityType,
      activityList,
      activityInfo = {},
      isVipRebuy,
      giftListActivity,
      defaultActivityList
    } = this;
    let groupKey = 0;
    let activityIdList = [];
    if (activityType != 10 && this.activityId) {
      // 秒杀团购预售
      groupKey = 1024;
      activityIdList = [this.activityId];
    } else {
      if (activityList && activityList.length > 0) {
        for (let i = 0; i < activityList.length; i++) {
          const { activityBaseInfoList } = activityList[i];
          for (let j = 0; j < toJS(activityBaseInfoList).length; j++) {
            const { selected, activityId } = toJS(activityBaseInfoList)[j];
            if (selected) {
              if (activityId) {
                activityIdList.push(activityId);
                groupKey = 1024;
              }
            }
          }
        }
      }
    }

    const items = [
      {
        itemNum: this.itemNum,
        itemPrice: price,
        itemSerial: id,
        skuSerial: skuId,
        activityIdList,
        groupKey
      }
    ];
    // 如果是拼团、预售、秒杀活动（7 <= activityType <= 10）
    const { activityId, itemId } = activityInfo || {};
    if (activityType >= 7 && activityType <= 9 && activityId) {
      items[0].groupKey = parseInt(activityId);
    }

    let bizGiveawayReqDto = {};

    this.handleSelectedGiftList();

    if (this.giftActId) {
      let it = this.handleGiftSettle(
        toJS(this.selectedGiftList),
        activityIdList,
        groupKey,
        giftListActivity
      );
      for (const item of it) {
        if (item.giftType == 1) {
          giftItems = [...giftItems, ...item.items];
        } else {
          couponRightsList = [...couponRightsList, ...item.items];
        }
      }

      if (this.activityInfo) {
        Util.setLocalCache(Config.localStorageKeys.shop_checkOrderParams, {
          activityInfo: this.activityInfo
        });
      }
      bizGiveawayReqDto = {
        giftType: it.giftType,
        freeItem: giftItems,
        giftList: couponRightsList
      };
    }

    if (this.incPriceId) {
      let cheapItems = this.incPriceList
        .filter((item) => item.itemNum > 0 && this.selectedGiftItems[item.itemId])
        .map((item) => ({
          activityIdList,
          groupKey: 1024,
          itemNum: item.itemNum || 0,
          itemPrice: item.salePrice,
          itemSerial: item.itemId,
          skuSerial: item.skuId
        }));
      bizGiveawayReqDto.cheapItem = cheapItems;
    }
    let params = {
      items,
      activityType,
      itemId, // 商品id
      activityId, // 活动id
      orderType: isVipRebuy ? 10 : this.orderType,
      orderProperty: this.orderProperty,
      bizGiveawayReqDto,
      isVipRebuy,
      isShopMasterMode: this.isShopMasterMode
    };
    // 新增折扣信息
    if (this.isDiscountMode && !this.isActivityMode) {
      params.discount = allowDiscount ? this.discount : 1;
      params.orderProperty = 1;
    }
    if (this.isShopMasterMode) {
      params.discount = this.discount;
      params.orderProperty = this.orderProperty;
    }

    Stores.CheckOrderMod.confirmOrder(params, 1, undefined, undefined, isInit).then((res) => {
      console.log('res', res);
      res && this.changeState({ NowPriceAndBvInfo: res });
    });
  };

  /**
   * 获取运费
   */
  getFreight = flow(function* () {
    const distributeRadio = this.col2List[this.orderType] || {};
    // 如果还没选择地址，不计算运费
    if (!this.addressInfo || !this.addressInfo.cityCode || distributeRadio.value === -1) {
      return;
    }

    const { id, price, skuId } = this.productInfo;
    const item = {
      itemNum: this.itemNum,
      itemSerial: id,
      itemPrice: price,
      skuSerial: skuId
    };

    let params = {
      items: [item],
      areaCode: this.addressInfo.cityCode,
      deliveryType: '1',
      orderProperty: this.orderProperty || '1',
      totalOrderAmount: multiply(this.itemNum, price),
      couponFreight: 0,
      availableItemIds: []
    };

    try {
      const { data, resultCode } = yield Serv.getFreight(params);

      if (resultCode == 0) {
        this.freeShippingData = data;
      } else {
        this.freeShippingData = { amount: 0, showType: 0 };
      }
    } catch (e) {
      this.freeShippingData = { amount: 0, showType: 0 };
      console.log('getFreight e', e);
    }
  });

  /**
   * 获取满赠列表
   */
  getdefaultActivityGiftList = flow(function* (theQuestId) {
    try {
      const { data, resultCode } = yield Serv.getActivityIdsGiftList({
        activityIds: theQuestId
      });
      let giftItems = [];
      let couponRightsList = [];
      if (`${resultCode}` == '0') {
        data.forEach((datas, index) => {
          let giftType = get(datas, 'giftType');
          let presentCount = get(datas, 'presentCount');
          let activityId = get(datas, 'activityId');
          let presentWay = get(datas, 'presentWay');
          let newgiftItemList = [];
          if (get(datas, 'giftItemList', []) && get(datas, 'giftItemList', []).length > 0) {
            newgiftItemList = get(datas, 'giftItemList', []).map((item) => {
              item.activityId = activityId;
              return item;
            });
          }
          let newCouponList = [];
          if (get(datas, 'couponList', []) && get(datas, 'couponList', []).length > 0) {
            newCouponList = get(datas, 'couponList', []).map((item) => {
              item.activityId = activityId;
              item.couponName = item.couponName || item.giftCouponName;
              item.couponType =
                item.couponType !== undefined ? item.couponType : item.deductionType;
              item.couponValue = item.couponValue !== undefined ? item.couponValue : item.giftValue;
              return item;
            });
          }
          let newRightsList = [];
          if (get(datas, 'rightsList', []) && get(datas, 'rightsList', []).length > 0) {
            newRightsList = get(datas, 'rightsList', []).map((item) => {
              item.activityId = activityId;
              return item;
            });
          }
          let newGiftList = [];
          let theGiftList;
          if (+giftType === 5) {
            theGiftList = [...newgiftItemList, ...newCouponList];
            theGiftList.forEach((item) => {
              item.resolvedGiftType = item.couponType !== undefined ? 2 : 1;
              item.giftType = 5;
            });
          } else {
            theGiftList = [newgiftItemList, newCouponList, newRightsList][datas.giftType - 1] || [];
            theGiftList.forEach((item) => {
              item.giftType = item.giftType || +giftType;
            });
          }
          if (presentWay == 1) {
            newGiftList = theGiftList.map((item) => {
              const {
                id,
                price: itemPrice,
                couponName,
                giftCount,
                itemName,
                skuSerial,
                giftType: itemGiftType
              } = item || {};
              const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
              let commonObj = {
                groupKey: 1024,
                itemNum: giftCount,
                activityIdList: [activityId],
                giftType: effectiveType
              };
              if (effectiveType === 2) {
                commonObj = {
                  ...commonObj,
                  itemName: couponName,
                  giftNum: giftCount,
                  giftId: id
                };
              } else {
                commonObj = {
                  ...commonObj,
                  itemName,
                  skuSerial,
                  itemPrice,
                  itemSerial: id
                };
              }
              return commonObj;
            });
          } else if (presentWay == 2) {
            let count = presentCount;
            theGiftList.forEach((item) => {
              if (count > 0) {
                const {
                  itemSerial,
                  price: itemPrice,
                  giftCount: itemNum,
                  itemName,
                  skuSerial,
                  giftType: itemGiftType,
                  giftNum,
                  giftId
                } = item || {};
                const effectiveType = +giftType === 5 ? item.resolvedGiftType : +datas.giftType;
                let commonObj = {
                  groupKey: 1024,
                  itemName,
                  itemNum,
                  activityIdList: [activityId]
                };
                if (effectiveType === 2) {
                  commonObj = { ...commonObj, giftType: effectiveType, giftNum, giftId };
                } else {
                  commonObj = { ...commonObj, skuSerial, itemPrice, itemSerial };
                }
                newGiftList.push(commonObj);
                count--;
              }
            });
          }
          if (+giftType === 5) {
            newGiftList.forEach((item) => {
              if (item.giftType === 2) {
                couponRightsList = [...couponRightsList, item];
              } else {
                giftItems = [...giftItems, item];
              }
            });
          } else if (giftType == 1) {
            giftItems = [...giftItems, ...newGiftList];
          } else {
            couponRightsList = [...couponRightsList, ...newGiftList];
          }
        });
        return {
          giftItems,
          couponRightsList
        };
      }
    } catch (e) {}
  });

  @computed
  get discountList() {
    return Stores.AppMod.userInfo.discountList || [];
  }

  @computed
  get isDiscountMode() {
    return false;
    // return Stores.AppMod.userInfo.orderVersion == 1
  }

  // 店长配货模式
  @computed
  get isShopMasterMode() {
    if (!this.activityList || this.activityList.length == 0) {
      return false;
    }
    let flag = false;
    return flag;
  }

  // 店长配货比例
  @computed
  get shopMasterDistributionRatio() {
    if (!this.activityList || this.activityList.length == 0) {
      return {};
    }
    return {};
  }

  // 1:3店长物料不能加购物车
  @computed
  get allowDistributionRatio() {
    let flag = false;
    if (this.activityList && this.activityList.length > 0) {
      this.activityList.map((activityInfo) => {
        if (activityInfo.activityType === 6 && activityInfo.activityBaseInfoList) {
          activityInfo.activityBaseInfoList.map((item) => {
            if (item.allowDistributionRatio) {
              flag = true;
            }
          });
        }
      });
    }
    return flag;
  }

  // 拼团，预售，秒杀
  @computed
  get isActivityMode() {
    return this.activityInfo && [7, 8, 9].includes(this.activityInfo.activityType);
  }

  /**
   * 显示底部按钮
   */
  @computed
  get showBottomBtns() {
    const hasBlackList = this.blackActList && this.blackActList.length;
    return this.hasRequestStock && (this.activityId ? !!this.activityInfo : true) && !hasBlackList;
  }

  /**
   * 选择的加价购总数量
   */
  @computed
  get incPriceTotalCount() {
    let list = [0, ...this.incPriceList];
    return list.reduce((pre, next) => {
      return !this.selectedGiftItems[next.itemId] ? pre : pre + (next.itemNum || 0);
    });
  }

  /**
   * 选择的商品总数量
   */
  @computed
  get totalCount() {
    let num = 0;
    let cheapItems = this.incPriceList
      .filter((item) => item.itemNum > 0 && this.selectedGiftItems[item.itemId])
      .forEach((item) => {
        num += item.itemNum;
      });
    num += this.itemNum;

    return num;
  }

  /**
   * 查询秒杀拼团预售活动信息
   * 活动类型，1：满减，2：满赠实物，3：满赠券，4：满赠权益，5：折扣，6：加价购，7：预售，8：拼团，9：秒杀
   */
  getActivityInfo = flow(function* () {
    if (!this.activityId) {
      return;
    }
    this.bottomToolBarDisabled = true;

    try {
      const { data } = yield Serv.getActivityInfo(this.activityId, this.productId);
      this.activityInfo = data || {};
      const { limitBuyCount, flag = 1, itemMinBuy } = data || {};
      this.itemMinBuy = itemMinBuy;
      this.itemNum = itemMinBuy || 1;
      this.flag = flag;
      if (limitBuyCount > 0) {
        // 0表示不限制，大于0的即为限购数量
        this.limitNum = limitBuyCount;
      }
      const { activityType } = data;

      this.activityType = activityType;
      // 预售
      if (activityType === activityTypeMap.advanceSale) {
        this.prepareAdvanceInfo();
        this.getActivityDetail();
      }

      // 拼团
      if (activityType === activityTypeMap.groupBuy) {
        this.getGroupInfo();
        this.getActivityDetail();
      }

      this.handleOrderTypeAndRatio();
      this.bottomToolBarDisabled = false;
    } catch (error) {
      this.bottomToolBarDisabled = false;
    }
  });

  /**
   * 整合预售的信息，当前的预售状态，预售说明数据
   */
  prepareAdvanceInfo = () => {
    const {
      downPayment,
      preSellType,
      unifyPreSellTailPrice,
      payDownPaymentDateStart,
      payDownPaymentDateEnd,
      payFinalPaymentDateStart,
      payFinalPaymentDateEnd,
      countDownForDepositEnd,
      countDownForDepositStart,
      countDownForTailEnd,
      countDownForTailStart
    } = this.activityInfo;
    if (preSellType == advanceSaleTypeMap.DEPOSITSALE) {
      this.adVanceExplain = [
        {
          title: '定金',
          price: downPayment || 30,
          time: `(${formatTime(payDownPaymentDateStart, '{1}月{2}日{3}:{4}', false)}~${formatTime(
            payDownPaymentDateEnd,
            '{1}月{2}日{3}:{4}',
            false
          )})`,
          isShowMore: true
        },
        {
          title: '尾款',
          price: unifyPreSellTailPrice || 60,
          time: `(${formatTime(payFinalPaymentDateStart, '{1}月{2}日{3}:{4}', false)}~${formatTime(
            payFinalPaymentDateEnd,
            '{1}月{2}日{3}:{4}',
            false
          )})`,
          isShowMore: false
        }
      ];
    }

    if (countDownForDepositStart > 0 && countDownForDepositEnd > 0) {
      // 支付定金开始和结束时间都大于0，说明活动尚未开始
      this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYUNSTART;
      this.activityInfo.countDownForStart = countDownForDepositStart;
      this.activityInfo.countDownForEnd = countDownForDepositEnd;
      this.bottomToolBarDisabled = true;
    } else if (countDownForDepositStart < 0 && countDownForDepositEnd > 0) {
      // 支付定金阶段
      this.advanceSaleStatus = advanceSaleStatusMap.PAYFORDEPOSIT;
      this.activityInfo.countDownForStart = countDownForDepositStart;
      this.activityInfo.countDownForEnd = countDownForDepositEnd;
      this.bottomToolBarDisabled = false;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart > 0 &&
      countDownForTailEnd > 0
    ) {
      // 待付尾款阶段
      this.advanceSaleStatus = advanceSaleStatusMap.WAITFORTAIL;
      this.activityInfo.countDownForStart = countDownForTailStart;
      this.activityInfo.countDownForEnd = countDownForTailEnd;
      this.bottomToolBarDisabled = true;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart < 0 &&
      countDownForTailEnd > 0
    ) {
      // 支付尾款阶段
      this.advanceSaleStatus = advanceSaleStatusMap.PAYFORTAIL;
      this.activityInfo.countDownForStart = countDownForTailStart;
      this.activityInfo.countDownForEnd = countDownForTailEnd;
      this.bottomToolBarDisabled = false;
    } else if (
      countDownForDepositStart < 0 &&
      countDownForDepositEnd < 0 &&
      countDownForTailStart < 0 &&
      countDownForTailEnd < 0
    ) {
      // 活动结束
      this.advanceSaleStatus = advanceSaleStatusMap.ACTIVITYEND;
      this.activityInfo.countDownForStart = countDownForTailStart;
      this.activityInfo.countDownForEnd = countDownForTailEnd;
      this.bottomToolBarDisabled = true;
    }
  };

  /**
   * 查询拼团成团信息
   */
  getGroupInfo = flow(function* (pageNum = 1) {
    if (!this.activityId) {
      return;
    }
    try {
      let params = {
        itemId: this.productId,
        activityId: this.activityId,
        pageNum,
        pageSize: 2
      };
      const { data } = yield Serv.getActivityGroupList(params);
      const { groupList, memberCount } = data || {};
      const { list = [], pages, total } = groupList || {};
      if (pageNum == 1) {
        this.groupBuyList.data = list;
        this.groupBuyList.pageNum = groupList.pageNum;
        this.groupBuyList.pages = pages;
        this.groupBuyList.total = total;
        this.memberCount = memberCount;
      } else {
        const arr = this.groupBuyList.data || [];
        this.groupBuyList.pageNum = groupList.pageNum;
        this.groupBuyList.pages = pages;
        this.groupBuyList.data = arr.concat(list);
        this.groupBuyList.total = total;
        this.memberCount = memberCount;
      }
    } catch (error) {}
  });

  /**
   * 判断是否有预售或团购订单
   */
  checkCanBuy = flow(function* () {
    const { activityType, preSellType } = this.activityInfo;
    const type = activityType === activityTypeMap.advanceSale ? 0 : 1;
    try {
      let params = {
        itemId: this.productId,
        activityId: this.activityId,
        type
      };
      const { data } = yield Serv.checkCanBuy(params);

      const { tradeNo } = data || {};
      let ret = {};
      if ((tradeNo && type == 1) || (type == 0 && preSellType == advanceSaleTypeMap.DEPOSITSALE)) {
        ret.data = data;
        ret.activityType = activityType;
        ret.returnType = 'back';
      } else {
        ret.returnType = 'next';
      }
      this.checkData = ret || {};
    } catch (error) {}
  });

  /**
   * 判断是否可参团
   */
  checkCanJoin = flow(function* (groupOrderId) {
    try {
      const { data } = yield Serv.checkCanJoin(groupOrderId);
      let ret = {};
      if (data) {
        ret.tradeNo = data;
        ret.returnType = 'back';
      } else {
        ret.returnType = 'next';
      }
      this.checkData = ret || {};
    } catch (error) {}
  });

  /**
   * 获取活动详情
   */
  getActivityDetail = flow(function* () {
    if (!this.activityId) {
      return;
    }
    try {
      const { resultCode, data } = yield Serv.getActivityDetail(this.activityId);
      if (resultCode == 0) {
        const { baseReqDto = {} } = data || {};
        this.notCancelTag = baseReqDto.notCancelTag || 0; // 资格购活动是否禁止不带活动下单  0--允许  1--禁止
        this.description = baseReqDto.description;
        this.activityType = baseReqDto.activityType;
        this.activityAppDownloadGuide = baseReqDto.appDownloadGuide || '';
        this.appDownloadGuide = baseReqDto.appDownloadGuide;
        const { joinGroupFlag = 1 } = baseReqDto || {};
        this.joinGroupFlag = joinGroupFlag;
        this.flashSaleFullToGiveSuperpositionTag = !!baseReqDto.fullToGiveSuperpositionTag; //秒杀活动是否允许叠加满赠
        // 资格购活动是否允许取消活动以及必须下月复消订单 0-不可取消且只能下月复消订单 1-可取消可下任何订单类型
        // notCancelTag 后管配置项 1活动不可取消 0活动可取消
        this.qualificationUnCancel = data.canCancel === 0 || baseReqDto.notCancelTag === 1;
        // 资格购活动是否允许跨越用户支持的资格购配货比例下单
        this.cargoScalePriorityTag = baseReqDto.cargoScalePriorityTag;
        this.activityDetail = data;
      }
    } catch (error) {}
  });

  // 获取标题名称
  getTitleName = flow(function* (subActivityId) {
    try {
      const { data, resultCode } = yield Serv.getTitleName(subActivityId);
      if (+resultCode === 0 && data) {
        this.titleName = data.subName;
        Stores.AppMod.changeState('titleName', data.subName);
      }
    } catch (error) {}
  });

  getQualificationList = flow(function* () {
    try {
      const { data } = yield Serv.getQualificationList({ isPurchasingAgent: 0 });
      const qualificationList = data || [];
      return qualificationList;
    } catch (err) {}
  });

  getBannerDetails = flow(function* () {
    try {
      const { data } = yield Serv.getBannerDetails(this.productId);
      this.bannerDetails = data || {};
    } catch (err) {}
  });

  // 上报名片信息
  addViewItem = flow(function* (params) {
    try {
      const { data } = yield Serv.addViewItem(params);
    } catch (err) {}
  });

  /**
   * 查询是否可开实体卡或虚拟卡
   */
  queryCanApplyType = flow(function* () {
    try {
      const { healthConsultantNum, phone } = Stores.AppMod.userInfo;
      const params = {
        channel: 0,
        healthConsultantCardCode: healthConsultantNum || '8888888888'
      };
      const { data } = yield Serv.queryCanApplyType(params);
      // 0 - 只能开虚拟卡，1 - 只能开实体卡，2 - 可开虚拟卡或实体卡
      if (data != 0) {
        // ignoreFictitious: 是否不可开虚拟卡
        window.app.routerGoTo({
          pathname: '/register/physicalCard',
          state: {
            ignoreFictitious: data == 1,
            applyType: '3',
            phone
          }
        });
      } else {
        window.app.routerGoTo({
          pathname: '/register/memCardMsg',
          state: {
            applyType: '3',
            phone
          }
        });
      }
    } catch (error) {}
  });
  // 获取推荐文章列表
  getRecommendArticleList = flow(function* () {
    try {
      const paramsData = {
        itemId: this.productId,
        type: 'article'
      };

      const { data } = yield Serv.getRecommendArticleList({ pageNum: 1, pageSize: 2 }, paramsData);
      this.recommendArticleList = data.list || [];
    } catch (error) {
      console.log(error);
    }
  });

  // getShareId
  getShareId = flow(function* () {
    if (!Stores.AppMod.token) {
      return 'no login';
    }
    try {
      const paramsData = {
        shareContentId: this.productId,
        type: 1
      };

      const { data } = yield Serv.getShareId(paramsData);
      this.shareId = data.shareId;
    } catch (error) {
      console.log(error);
    }
  });
  // 获取推荐素材列表
  getRecommendMeterialList = flow(function* () {
    try {
      const paramsData = {
        itemId: this.productId,
        type: 'material',
        materialType: ''
      };

      const { data } = yield Serv.getRecommendArticleList({ pageNum: 1, pageSize: 2 }, paramsData);
      this.recommendMaterialList = data.list || [];
    } catch (error) {
      console.log(error);
    }
  });

  /**
   * 是否有1：2配货比例的弹窗
   *
   */
  getDistributionTip = flow(function* () {
    const { items, bizGiveawayReqDto } = this.getListParam();
    const { isVipRebuy, activityInfo = {} } = this;
    const { userInfo = {} } = Stores.AppMod || {};
    let getInfo = +this.autoComplete === 2 ? 'autoComplete' : '';
    let params = {
      items,
      orderType: isVipRebuy ? 10 : this.orderType,
      orderProperty: isVipRebuy ? 1 : this.orderProperty,
      bizGiveawayReqDto
    };
    if (userInfo.systemType === 0) {
      params.multiActivityValidateFlag = true;
    }
    if (getInfo === 'autoComplete') {
      params.teamOrderInitiator = Stores.AppMod.userInfo.id;
    }

    try {
      const result = yield Serv.getDistributionTip(params);

      if (result && result.resultCode == '0') {
        // 宫主会不提示
        return result.data == 1 && !this.isPriaItem;
      }
      return false;
    } catch (error) {
      return false;
    }
  });

  /**
   * 查询是否绑定过微信
   */
  queryBindFlag = flow(function* () {
    if (Stores.AppMod.isInternationalized) return true; // 国际版不需要绑定微信
    try {
      const result = yield Serv.queryBindFlag();
      if (result && result.resultCode === '0') {
        return result.data; // 0未关联 1已关联
      } else {
        return 1;
      }
    } catch (err) {
      return 1;
    }
  });

  /**
   *  获取跳转链接
   *
   */
  getWechatLoginUrl = flow(function* (params) {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getWechatLoginUrl(params);
      if (+resultCode === 0) {
        return data;
      }
    } catch (error) {}
  });

  // 多规格商品
  getMoreMultiList = flow(function* (id) {
    let subItemList = (this.activityInfo && this.activityInfo.subItemList) || [];
    // if (toJS(subItemList).length > 0) {
    //   this.moreSpecificationsData = toJS(subItemList)
    //   return
    // }
    // let _subItemList = toJS(subItemList) //资格购传入的list
    let _subItemList = [];
    try {
      const { data } = yield Serv.getMoreMultiList(id);
      if (data && data.subItem) {
        let dataList = data.subItem || [];
        if (_subItemList.length > 0) {
          _subItemList.forEach((item) => {
            dataList.forEach((ele) => {
              if (ele.code == item.itemCode) {
                // ele.price = item.discountSalePrice
                item.mediaRespDtoList = ele.mediaRespDtoList;
              }
            });
          });
          this.moreSpecificationsData = _subItemList;
          return;
        }
        this.moreSpecificationsData = dataList;
      }
      return data;
    } catch (e) {}
  });

  /**
   * 获取日常任务列表
   * @param {Number} pageNum 页面
   * @param {Number} pageSize 数量
   */
  queryTaskList = flow(function* () {
    try {
      const { data } = yield Serv.queryTaskList();
      if (data) {
        return data.list;
      }
      return [];
    } catch (e) {
      return [];
    }
  });

  /**
   * 完成行为相关参数上报
   * params:参数
   */

  finishTask = flow(function* (params) {
    try {
      const result = yield Serv.finishTaskReport(params);
      if (result && result.data) {
        this.coninSuccessData = result.data;
        return result.data;
      }
      return false;
    } catch (e) {
      return false;
    }
  });

  // 获取商品卖点
  getProductSellPoint = flow(function* () {
    try {
      const { data, resultCode, resultMsg } = yield Serv.getProductSellPoint(this.productId);
    } catch (err) {
      console.log(err);
    }
  });

  /**
   * 三生体系未登录的情况下，是否显示下载app读公司的权限点
   * 获取权限点
   */
  getGongSiEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getGongSiEnterList();
      if (data) {
        const list = [];
        for (let key in data) {
          const datas = data[key];
          datas.forEach((item) => {
            list.push(item.routeKey);
          });
        }

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {}
  });

  /**
   * 新体系未登录的情况下，可以直接调取获取权限点
   * 获取权限点
   */
  getEnterList = flow(function* () {
    try {
      const { data } = yield Serv.getEnterList();

      const list = [];
      if (data) {
        //1-展业 2-我的 3-有享助手

        data.forEach((item) => {
          //enterType: 1-路由，2-标签
          list.push(item.routeKey);
        });

        const downloadKey = list.find((routerKey) => routerKey === routeAuthCodeMap.DOWNLOAD_BOOT);

        this.hasPermissions = !Stores.AppMod.token && !!downloadKey;
      }
    } catch (err) {
      console.log('dhjsakhda===>err', err);
    }
  });

  /**
   * 获取用户地址列表
   *
   * @memberof ShoppingCartMod
   */
  getAddressList = flow(function* () {
    try {
      const { data } = yield (
        getThinUserState() || getIsUnsubscribeOrSleep() ? Serv.getLogistics : Serv.getAddressList
      )();
      if (data && data.list) {
        const list = data.list || [];
        this.addressInfo = list.find((address) => address.status === 1) || list[0] || {};
      }
      return data;
    } catch (e) {}
  });

  /**
   * 获取宫主会购物车数量
   */
  getPriaCount = flow(function* () {
    try {
      const { data } = yield Serv.getPriaCount();
      this.priaCount = data || 0;
    } catch (e) {
      this.priaCount = 0;
    }
  });

  /**
   * 加入宫主会购物车
   */
  addPriaCart = flow(function* (params) {
    try {
      yield Serv.addPriaCart(params);
      return true;
    } catch (e) {
      return false;
    }
  });

  checkActivity = flow(function* (params) {
    try {
      const { data } = yield Serv.checkActivity(params);
      return data;
    } catch (e) {
      return false;
    }
  });
}

export default ProductDetailMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Product/ProductDetail/ProductDetailMod.js